const country_detail = [
    {
        "continent": "EU",
        "capital": "Andorra la Vella",
        "languages": "ca",
        "geonameId": 3041565,
        "south": 42.42874300100004,
        "isoAlpha3": "AND",
        "north": 42.65576500000003,
        "fipscode": "AN",
        "population": "84000",
        "east": 1.786576000000025,
        "isoNumeric": "020",
        "areaInSqKm": "468.0",
        "countrycode": "AD",
        "west": 1.413760001000071,
        "countryName": "Andorra",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AS",
        "capital": "Abu Dhabi",
        "languages": "ar-AE,fa,en,hi,ur",
        "geonameId": 290557,
        "south": 22.631513764,
        "isoAlpha3": "ARE",
        "north": 26.0693916660001,
        "fipscode": "AE",
        "population": "4975593",
        "east": 56.381564568,
        "isoNumeric": "784",
        "areaInSqKm": "82880.0",
        "countrycode": "AE",
        "west": 51.572410727,
        "countryName": "United Arab Emirates",
        "continentName": "Asia",
        "currencycode": "AED"
    },
    {
        "continent": "AS",
        "capital": "Kabul",
        "languages": "fa-AF,ps,uz-AF,tk",
        "geonameId": 1149361,
        "south": 29.3770645357176,
        "isoAlpha3": "AFG",
        "north": 38.4907920755748,
        "fipscode": "AF",
        "population": "29121286",
        "east": 74.8894511481168,
        "isoNumeric": "004",
        "areaInSqKm": "647500.0",
        "countrycode": "AF",
        "west": 60.4720833972263,
        "countryName": "Afghanistan",
        "continentName": "Asia",
        "currencycode": "AFN"
    },
    {
        "continent": "NA",
        "capital": "St. John's",
        "languages": "en-AG",
        "geonameId": 3576396,
        "south": 16.9986381530001,
        "isoAlpha3": "ATG",
        "north": 17.72910877443121,
        "fipscode": "AC",
        "population": "86754",
        "east": -61.672164917,
        "isoNumeric": "028",
        "areaInSqKm": "443.0",
        "countrycode": "AG",
        "west": -61.90630722,
        "countryName": "Antigua and Barbuda",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "NA",
        "capital": "The Valley",
        "languages": "en-AI",
        "geonameId": 3573511,
        "south": 18.160292974311673,
        "isoAlpha3": "AIA",
        "north": 18.276901971658063,
        "fipscode": "AV",
        "population": "13254",
        "east": -62.96655544577948,
        "isoNumeric": "660",
        "areaInSqKm": "102.0",
        "countrycode": "AI",
        "west": -63.16808989603879,
        "countryName": "Anguilla",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "EU",
        "capital": "Tirana",
        "languages": "sq,el",
        "geonameId": 783754,
        "south": 39.6448624829142,
        "isoAlpha3": "ALB",
        "north": 42.6611669383269,
        "fipscode": "AL",
        "population": "2986952",
        "east": 21.0574334835312,
        "isoNumeric": "008",
        "areaInSqKm": "28748.0",
        "countrycode": "AL",
        "west": 19.2639112711741,
        "countryName": "Albania",
        "continentName": "Europe",
        "currencycode": "ALL"
    },
    {
        "continent": "AS",
        "capital": "Yerevan",
        "languages": "hy",
        "geonameId": 174982,
        "south": 38.841972,
        "isoAlpha3": "ARM",
        "north": 41.301834,
        "fipscode": "AM",
        "population": "2968000",
        "east": 46.6289052796227,
        "isoNumeric": "051",
        "areaInSqKm": "29800.0",
        "countrycode": "AM",
        "west": 43.44978000000003,
        "countryName": "Armenia",
        "continentName": "Asia",
        "currencycode": "AMD"
    },
    {
        "continent": "AF",
        "capital": "Luanda",
        "languages": "pt-AO",
        "geonameId": 3351879,
        "south": -18.042076,
        "isoAlpha3": "AGO",
        "north": -4.376826,
        "fipscode": "AO",
        "population": "13068161",
        "east": 24.082119,
        "isoNumeric": "024",
        "areaInSqKm": "1246700.0",
        "countrycode": "AO",
        "west": 11.679219,
        "countryName": "Angola",
        "continentName": "Africa",
        "currencycode": "AOA"
    },
    {
        "continent": "AN",
        "capital": "",
        "languages": "",
        "geonameId": 6697173,
        "south": -89.9999,
        "isoAlpha3": "ATA",
        "north": -60.515533,
        "fipscode": "AY",
        "population": "0",
        "east": 179.9999,
        "isoNumeric": "010",
        "areaInSqKm": "1.4E7",
        "countrycode": "AQ",
        "west": -179.9999,
        "countryName": "Antarctica",
        "continentName": "Antarctica",
        "currencycode": ""
    },
    {
        "continent": "SA",
        "capital": "Buenos Aires",
        "languages": "es-AR,en,it,de,fr,gn",
        "geonameId": 3865483,
        "south": -55.0576984539999,
        "isoAlpha3": "ARG",
        "north": -21.777951173,
        "fipscode": "AR",
        "population": "41343201",
        "east": -53.637962552,
        "isoNumeric": "032",
        "areaInSqKm": "2766890.0",
        "countrycode": "AR",
        "west": -73.566302817,
        "countryName": "Argentina",
        "continentName": "South America",
        "currencycode": "ARS"
    },
    {
        "continent": "OC",
        "capital": "Pago Pago",
        "languages": "en-AS,sm,to",
        "geonameId": 5880801,
        "south": -14.373776,
        "isoAlpha3": "ASM",
        "north": -11.047857,
        "fipscode": "AQ",
        "population": "57881",
        "east": -169.418925,
        "isoNumeric": "016",
        "areaInSqKm": "199.0",
        "countrycode": "AS",
        "west": -171.090042,
        "countryName": "American Samoa",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "EU",
        "capital": "Vienna",
        "languages": "de-AT,hr,hu,sl",
        "geonameId": 2782113,
        "south": 46.3726520216244,
        "isoAlpha3": "AUT",
        "north": 49.0211627691393,
        "fipscode": "AU",
        "population": "8205000",
        "east": 17.1620685652599,
        "isoNumeric": "040",
        "areaInSqKm": "83858.0",
        "countrycode": "AT",
        "west": 9.53095237240833,
        "countryName": "Austria",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "OC",
        "capital": "Canberra",
        "languages": "en-AU",
        "geonameId": 2077456,
        "south": -43.64397,
        "isoAlpha3": "AUS",
        "north": -10.062805,
        "fipscode": "AS",
        "population": "21515754",
        "east": 153.639252,
        "isoNumeric": "036",
        "areaInSqKm": "7686850.0",
        "countrycode": "AU",
        "west": 112.911057,
        "countryName": "Australia",
        "continentName": "Oceania",
        "currencycode": "AUD"
    },
    {
        "continent": "NA",
        "capital": "Oranjestad",
        "languages": "nl-AW,pap,es,en",
        "geonameId": 3577279,
        "south": 12.411707706190716,
        "isoAlpha3": "ABW",
        "north": 12.623718127152925,
        "fipscode": "AA",
        "population": "71566",
        "east": -69.86575120104982,
        "isoNumeric": "533",
        "areaInSqKm": "193.0",
        "countrycode": "AW",
        "west": -70.0644737196045,
        "countryName": "Aruba",
        "continentName": "North America",
        "currencycode": "AWG"
    },
    {
        "continent": "EU",
        "capital": "Mariehamn",
        "languages": "sv-AX",
        "geonameId": 661882,
        "south": 59.90675,
        "isoAlpha3": "ALA",
        "north": 60.488861,
        "fipscode": "",
        "population": "26711",
        "east": 21.011862,
        "isoNumeric": "248",
        "areaInSqKm": "1580.0",
        "countrycode": "AX",
        "west": 19.317694,
        "countryName": "Åland",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AS",
        "capital": "Baku",
        "languages": "az,ru,hy",
        "geonameId": 587116,
        "south": 38.38915252685547,
        "isoAlpha3": "AZE",
        "north": 41.90564,
        "fipscode": "AJ",
        "population": "8303512",
        "east": 50.370083,
        "isoNumeric": "031",
        "areaInSqKm": "86600.0",
        "countrycode": "AZ",
        "west": 44.774113,
        "countryName": "Azerbaijan",
        "continentName": "Asia",
        "currencycode": "AZN"
    },
    {
        "continent": "EU",
        "capital": "Sarajevo",
        "languages": "bs,hr-BA,sr-BA",
        "geonameId": 3277605,
        "south": 42.555473846,
        "isoAlpha3": "BIH",
        "north": 45.276539649,
        "fipscode": "BK",
        "population": "4590000",
        "east": 19.6237016800001,
        "isoNumeric": "070",
        "areaInSqKm": "51129.0",
        "countrycode": "BA",
        "west": 15.728732108,
        "countryName": "Bosnia and Herzegovina",
        "continentName": "Europe",
        "currencycode": "BAM"
    },
    {
        "continent": "NA",
        "capital": "Bridgetown",
        "languages": "en-BB",
        "geonameId": 3374084,
        "south": 13.0448331850001,
        "isoAlpha3": "BRB",
        "north": 13.3358612060001,
        "fipscode": "BB",
        "population": "285653",
        "east": -59.420749664,
        "isoNumeric": "052",
        "areaInSqKm": "431.0",
        "countrycode": "BB",
        "west": -59.6526374819999,
        "countryName": "Barbados",
        "continentName": "North America",
        "currencycode": "BBD"
    },
    {
        "continent": "AS",
        "capital": "Dhaka",
        "languages": "bn-BD,en",
        "geonameId": 1210997,
        "south": 20.743334,
        "isoAlpha3": "BGD",
        "north": 26.631945,
        "fipscode": "BG",
        "population": "156118464",
        "east": 92.673668,
        "isoNumeric": "050",
        "areaInSqKm": "144000.0",
        "countrycode": "BD",
        "west": 88.028336,
        "countryName": "Bangladesh",
        "continentName": "Asia",
        "currencycode": "BDT"
    },
    {
        "continent": "EU",
        "capital": "Brussels",
        "languages": "nl-BE,fr-BE,de-BE",
        "geonameId": 2802361,
        "south": 49.496968483036,
        "isoAlpha3": "BEL",
        "north": 51.5051118897455,
        "fipscode": "BE",
        "population": "10403000",
        "east": 6.40793743953125,
        "isoNumeric": "056",
        "areaInSqKm": "30510.0",
        "countrycode": "BE",
        "west": 2.54132898439873,
        "countryName": "Belgium",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Ouagadougou",
        "languages": "fr-BF,mos",
        "geonameId": 2361809,
        "south": 9.41047177500008,
        "isoAlpha3": "BFA",
        "north": 15.084033447,
        "fipscode": "UV",
        "population": "16241811",
        "east": 2.40435976900005,
        "isoNumeric": "854",
        "areaInSqKm": "274200.0",
        "countrycode": "BF",
        "west": -5.51324157299996,
        "countryName": "Burkina Faso",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "EU",
        "capital": "Sofia",
        "languages": "bg,tr-BG,rom",
        "geonameId": 732800,
        "south": 41.2353414930001,
        "isoAlpha3": "BGR",
        "north": 44.215451,
        "fipscode": "BU",
        "population": "7148785",
        "east": 28.6102771760001,
        "isoNumeric": "100",
        "areaInSqKm": "110910.0",
        "countrycode": "BG",
        "west": 22.357156753,
        "countryName": "Bulgaria",
        "continentName": "Europe",
        "currencycode": "BGN"
    },
    {
        "continent": "AS",
        "capital": "Manama",
        "languages": "ar-BH,en,fa,ur",
        "geonameId": 290291,
        "south": 25.790910001,
        "isoAlpha3": "BHR",
        "north": 26.3308150010001,
        "fipscode": "BA",
        "population": "738004",
        "east": 50.720622,
        "isoNumeric": "048",
        "areaInSqKm": "665.0",
        "countrycode": "BH",
        "west": 50.3158550000001,
        "countryName": "Bahrain",
        "continentName": "Asia",
        "currencycode": "BHD"
    },
    {
        "continent": "AF",
        "capital": "Bujumbura",
        "languages": "fr-BI,rn",
        "geonameId": 433561,
        "south": -4.46932899899997,
        "isoAlpha3": "BDI",
        "north": -2.30973016299993,
        "fipscode": "BY",
        "population": "9863117",
        "east": 30.84954,
        "isoNumeric": "108",
        "areaInSqKm": "27830.0",
        "countrycode": "BI",
        "west": 29.0009680000001,
        "countryName": "Burundi",
        "continentName": "Africa",
        "currencycode": "BIF"
    },
    {
        "continent": "AF",
        "capital": "Porto-Novo",
        "languages": "fr-BJ",
        "geonameId": 2395170,
        "south": 6.23477794100006,
        "isoAlpha3": "BEN",
        "north": 12.4086110000001,
        "fipscode": "BN",
        "population": "9056010",
        "east": 3.84306303800003,
        "isoNumeric": "204",
        "areaInSqKm": "112620.0",
        "countrycode": "BJ",
        "west": 0.775412326000037,
        "countryName": "Benin",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "NA",
        "capital": "Gustavia",
        "languages": "fr",
        "geonameId": 3578476,
        "south": 17.878183227405575,
        "isoAlpha3": "BLM",
        "north": 17.928808791949283,
        "fipscode": "TB",
        "population": "8450",
        "east": -62.788983372985854,
        "isoNumeric": "652",
        "areaInSqKm": "21.0",
        "countrycode": "BL",
        "west": -62.8739118253784,
        "countryName": "Saint Barthélemy",
        "continentName": "North America",
        "currencycode": "EUR"
    },
    {
        "continent": "NA",
        "capital": "Hamilton",
        "languages": "en-BM,pt",
        "geonameId": 3573345,
        "south": 32.247551,
        "isoAlpha3": "BMU",
        "north": 32.39122351646162,
        "fipscode": "BD",
        "population": "65365",
        "east": -64.64718648144532,
        "isoNumeric": "060",
        "areaInSqKm": "53.0",
        "countrycode": "BM",
        "west": -64.88723800000002,
        "countryName": "Bermuda",
        "continentName": "North America",
        "currencycode": "BMD"
    },
    {
        "continent": "AS",
        "capital": "Bandar Seri Begawan",
        "languages": "ms-BN,en-BN",
        "geonameId": 1820814,
        "south": 4.00264384400003,
        "isoAlpha3": "BRN",
        "north": 5.04571171901151,
        "fipscode": "BX",
        "population": "395027",
        "east": 115.364671704,
        "isoNumeric": "096",
        "areaInSqKm": "5770.0",
        "countrycode": "BN",
        "west": 114.075926291,
        "countryName": "Brunei",
        "continentName": "Asia",
        "currencycode": "BND"
    },
    {
        "continent": "SA",
        "capital": "Sucre",
        "languages": "es-BO,qu,ay",
        "geonameId": 3923057,
        "south": -22.89809,
        "isoAlpha3": "BOL",
        "north": -9.66932299899997,
        "fipscode": "BL",
        "population": "9947418",
        "east": -57.4538029999999,
        "isoNumeric": "068",
        "areaInSqKm": "1098580.0",
        "countrycode": "BO",
        "west": -69.644939573,
        "countryName": "Bolivia",
        "continentName": "South America",
        "currencycode": "BOB"
    },
    {
        "continent": "NA",
        "capital": "Kralendijk",
        "languages": "nl,pap,en",
        "geonameId": 7626844,
        "south": 12.024024222896262,
        "isoAlpha3": "BES",
        "north": 12.312385778727828,
        "fipscode": "",
        "population": "18012",
        "east": -68.19423837039591,
        "isoNumeric": "535",
        "areaInSqKm": "328.0",
        "countrycode": "BQ",
        "west": -68.42092654856276,
        "countryName": "Bonaire",
        "continentName": "North America",
        "currencycode": "USD"
    },
    {
        "continent": "SA",
        "capital": "Brasília",
        "languages": "pt-BR,es,en,fr",
        "geonameId": 3469034,
        "south": -33.750706,
        "isoAlpha3": "BRA",
        "north": 5.264877,
        "fipscode": "BR",
        "population": "201103330",
        "east": -32.392998,
        "isoNumeric": "076",
        "areaInSqKm": "8511965.0",
        "countrycode": "BR",
        "west": -73.985535,
        "countryName": "Brazil",
        "continentName": "South America",
        "currencycode": "BRL"
    },
    {
        "continent": "NA",
        "capital": "Nassau",
        "languages": "en-BS",
        "geonameId": 3572887,
        "south": 22.852743,
        "isoAlpha3": "BHS",
        "north": 26.919243,
        "fipscode": "BF",
        "population": "301790",
        "east": -74.423874,
        "isoNumeric": "044",
        "areaInSqKm": "13940.0",
        "countrycode": "BS",
        "west": -78.995911,
        "countryName": "Bahamas",
        "continentName": "North America",
        "currencycode": "BSD"
    },
    {
        "continent": "AS",
        "capital": "Thimphu",
        "languages": "dz",
        "geonameId": 1252634,
        "south": 26.702020985,
        "isoAlpha3": "BTN",
        "north": 28.246987001,
        "fipscode": "BT",
        "population": "699847",
        "east": 92.12523192,
        "isoNumeric": "064",
        "areaInSqKm": "47000.0",
        "countrycode": "BT",
        "west": 88.7455215570001,
        "countryName": "Bhutan",
        "continentName": "Asia",
        "currencycode": "BTN"
    },
    {
        "continent": "AN",
        "capital": "",
        "languages": "",
        "geonameId": 3371123,
        "south": -54.4507993522734,
        "isoAlpha3": "BVT",
        "north": -54.3887383509872,
        "fipscode": "BV",
        "population": "0",
        "east": 3.434845577758324,
        "isoNumeric": "074",
        "areaInSqKm": "49.0",
        "countrycode": "BV",
        "west": 3.286776428037342,
        "countryName": "Bouvet Island",
        "continentName": "Antarctica",
        "currencycode": "NOK"
    },
    {
        "continent": "AF",
        "capital": "Gaborone",
        "languages": "en-BW,tn-BW",
        "geonameId": 933860,
        "south": -26.907545,
        "isoAlpha3": "BWA",
        "north": -17.778136999,
        "fipscode": "BC",
        "population": "2029307",
        "east": 29.375304,
        "isoNumeric": "072",
        "areaInSqKm": "600370.0",
        "countrycode": "BW",
        "west": 19.998903,
        "countryName": "Botswana",
        "continentName": "Africa",
        "currencycode": "BWP"
    },
    {
        "continent": "EU",
        "capital": "Minsk",
        "languages": "be,ru",
        "geonameId": 630336,
        "south": 51.262011,
        "isoAlpha3": "BLR",
        "north": 56.1724940010001,
        "fipscode": "BO",
        "population": "9685000",
        "east": 32.776820001,
        "isoNumeric": "112",
        "areaInSqKm": "207600.0",
        "countrycode": "BY",
        "west": 23.1781980010001,
        "countryName": "Belarus",
        "continentName": "Europe",
        "currencycode": "BYN"
    },
    {
        "continent": "NA",
        "capital": "Belmopan",
        "languages": "en-BZ,es",
        "geonameId": 3582678,
        "south": 15.8893,
        "isoAlpha3": "BLZ",
        "north": 18.496557,
        "fipscode": "BH",
        "population": "314522",
        "east": -87.776985,
        "isoNumeric": "084",
        "areaInSqKm": "22966.0",
        "countrycode": "BZ",
        "west": -89.224815,
        "countryName": "Belize",
        "continentName": "North America",
        "currencycode": "BZD"
    },
    {
        "continent": "NA",
        "capital": "Ottawa",
        "languages": "en-CA,fr-CA,iu",
        "geonameId": 6251999,
        "south": 41.67598,
        "isoAlpha3": "CAN",
        "north": 83.110626,
        "fipscode": "CA",
        "population": "33679000",
        "east": -52.636291,
        "isoNumeric": "124",
        "areaInSqKm": "9984670.0",
        "countrycode": "CA",
        "west": -141,
        "countryName": "Canada",
        "continentName": "North America",
        "currencycode": "CAD"
    },
    {
        "continent": "AS",
        "capital": "West Island",
        "languages": "ms-CC,en",
        "geonameId": 1547376,
        "south": -12.208725839,
        "isoAlpha3": "CCK",
        "north": -12.072459094,
        "fipscode": "CK",
        "population": "628",
        "east": 96.929489344,
        "isoNumeric": "166",
        "areaInSqKm": "14.0",
        "countrycode": "CC",
        "west": 96.816941408,
        "countryName": "Cocos [Keeling] Islands",
        "continentName": "Asia",
        "currencycode": "AUD"
    },
    {
        "continent": "AF",
        "capital": "Kinshasa",
        "languages": "fr-CD,ln,ktu,kg,sw,lua",
        "geonameId": 203312,
        "south": -13.459034999,
        "isoAlpha3": "COD",
        "north": 5.39200300000005,
        "fipscode": "CG",
        "population": "70916439",
        "east": 31.3146120000001,
        "isoNumeric": "180",
        "areaInSqKm": "2345410.0",
        "countrycode": "CD",
        "west": 12.202361491,
        "countryName": "Democratic Republic of the Congo",
        "continentName": "Africa",
        "currencycode": "CDF"
    },
    {
        "continent": "AF",
        "capital": "Bangui",
        "languages": "fr-CF,sg,ln,kg",
        "geonameId": 239880,
        "south": 2.22305300000005,
        "isoAlpha3": "CAF",
        "north": 11.017957,
        "fipscode": "CT",
        "population": "4844927",
        "east": 27.4583050000001,
        "isoNumeric": "140",
        "areaInSqKm": "622984.0",
        "countrycode": "CF",
        "west": 14.4150980000001,
        "countryName": "Central African Republic",
        "continentName": "Africa",
        "currencycode": "XAF"
    },
    {
        "continent": "AF",
        "capital": "Brazzaville",
        "languages": "fr-CG,kg,ln-CG",
        "geonameId": 2260494,
        "south": -5.04072158799994,
        "isoAlpha3": "COG",
        "north": 3.70779100000004,
        "fipscode": "CF",
        "population": "3039126",
        "east": 18.65042119,
        "isoNumeric": "178",
        "areaInSqKm": "342000.0",
        "countrycode": "CG",
        "west": 11.1520760600001,
        "countryName": "Republic of the Congo",
        "continentName": "Africa",
        "currencycode": "XAF"
    },
    {
        "continent": "EU",
        "capital": "Bern",
        "languages": "de-CH,fr-CH,it-CH,rm",
        "geonameId": 2658434,
        "south": 45.8191539516188,
        "isoAlpha3": "CHE",
        "north": 47.8098679329775,
        "fipscode": "SZ",
        "population": "8484100",
        "east": 10.4934735095497,
        "isoNumeric": "756",
        "areaInSqKm": "41290.0",
        "countrycode": "CH",
        "west": 5.95661377423453,
        "countryName": "Switzerland",
        "continentName": "Europe",
        "currencycode": "CHF"
    },
    {
        "continent": "AF",
        "capital": "Yamoussoukro",
        "languages": "fr-CI",
        "geonameId": 2287781,
        "south": 4.36035248000007,
        "isoAlpha3": "CIV",
        "north": 10.740015,
        "fipscode": "IV",
        "population": "21058798",
        "east": -2.49303099999997,
        "isoNumeric": "384",
        "areaInSqKm": "322460.0",
        "countrycode": "CI",
        "west": -8.60205899999994,
        "countryName": "Ivory Coast",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "OC",
        "capital": "Avarua",
        "languages": "en-CK,mi",
        "geonameId": 1899402,
        "south": -21.944164,
        "isoAlpha3": "COK",
        "north": -10.023114,
        "fipscode": "CW",
        "population": "21388",
        "east": -157.312134,
        "isoNumeric": "184",
        "areaInSqKm": "240.0",
        "countrycode": "CK",
        "west": -161.093658,
        "countryName": "Cook Islands",
        "continentName": "Oceania",
        "currencycode": "NZD"
    },
    {
        "continent": "SA",
        "capital": "Santiago",
        "languages": "es-CL",
        "geonameId": 3895114,
        "south": -55.909795409,
        "isoAlpha3": "CHL",
        "north": -17.4977759459999,
        "fipscode": "CI",
        "population": "16746491",
        "east": -66.416152278,
        "isoNumeric": "152",
        "areaInSqKm": "756950.0",
        "countrycode": "CL",
        "west": -80.8370287079999,
        "countryName": "Chile",
        "continentName": "South America",
        "currencycode": "CLP"
    },
    {
        "continent": "AF",
        "capital": "Yaoundé",
        "languages": "en-CM,fr-CM",
        "geonameId": 2233387,
        "south": 1.65590000000003,
        "isoAlpha3": "CMR",
        "north": 13.083334,
        "fipscode": "CM",
        "population": "19294149",
        "east": 16.1944080000001,
        "isoNumeric": "120",
        "areaInSqKm": "475440.0",
        "countrycode": "CM",
        "west": 8.49843402900007,
        "countryName": "Cameroon",
        "continentName": "Africa",
        "currencycode": "XAF"
    },
    {
        "continent": "AS",
        "capital": "Beijing",
        "languages": "zh-CN,yue,wuu,dta,ug,za",
        "geonameId": 1814991,
        "south": 15.775416,
        "isoAlpha3": "CHN",
        "north": 53.560974001,
        "fipscode": "CH",
        "population": "1330044000",
        "east": 134.7754563,
        "isoNumeric": "156",
        "areaInSqKm": "9596960.0",
        "countrycode": "CN",
        "west": 73.4994140000001,
        "countryName": "China",
        "continentName": "Asia",
        "currencycode": "CNY"
    },
    {
        "continent": "SA",
        "capital": "Bogotá",
        "languages": "es-CO",
        "geonameId": 3686110,
        "south": -4.22839224299997,
        "isoAlpha3": "COL",
        "north": 13.38600323,
        "fipscode": "CO",
        "population": "47790000",
        "east": -66.8472153989999,
        "isoNumeric": "170",
        "areaInSqKm": "1138910.0",
        "countrycode": "CO",
        "west": -81.735775648,
        "countryName": "Colombia",
        "continentName": "South America",
        "currencycode": "COP"
    },
    {
        "continent": "NA",
        "capital": "San José",
        "languages": "es-CR,en",
        "geonameId": 3624060,
        "south": 8.03962731803416,
        "isoAlpha3": "CRI",
        "north": 11.2197589122308,
        "fipscode": "CS",
        "population": "4516220",
        "east": -82.552318987959,
        "isoNumeric": "188",
        "areaInSqKm": "51100.0",
        "countrycode": "CR",
        "west": -85.9502523586265,
        "countryName": "Costa Rica",
        "continentName": "North America",
        "currencycode": "CRC"
    },
    {
        "continent": "NA",
        "capital": "Havana",
        "languages": "es-CU,pap",
        "geonameId": 3562981,
        "south": 19.828083,
        "isoAlpha3": "CUB",
        "north": 23.226042,
        "fipscode": "CU",
        "population": "11423000",
        "east": -74.131775,
        "isoNumeric": "192",
        "areaInSqKm": "110860.0",
        "countrycode": "CU",
        "west": -84.957428,
        "countryName": "Cuba",
        "continentName": "North America",
        "currencycode": "CUP"
    },
    {
        "continent": "AF",
        "capital": "Praia",
        "languages": "pt-CV",
        "geonameId": 3374766,
        "south": 14.8152942670001,
        "isoAlpha3": "CPV",
        "north": 17.204706193,
        "fipscode": "CV",
        "population": "508659",
        "east": -22.6674270629999,
        "isoNumeric": "132",
        "areaInSqKm": "4033.0",
        "countrycode": "CV",
        "west": -25.3609161379999,
        "countryName": "Cape Verde",
        "continentName": "Africa",
        "currencycode": "CVE"
    },
    {
        "continent": "NA",
        "capital": "Willemstad",
        "languages": "nl,pap",
        "geonameId": 7626836,
        "south": 12.032745,
        "isoAlpha3": "CUW",
        "north": 12.385672,
        "fipscode": "UC",
        "population": "141766",
        "east": -68.733948,
        "isoNumeric": "531",
        "areaInSqKm": "444.0",
        "countrycode": "CW",
        "west": -69.157204,
        "countryName": "Curacao",
        "continentName": "North America",
        "currencycode": "ANG"
    },
    {
        "continent": "OC",
        "capital": "Flying Fish Cove",
        "languages": "en,zh,ms-CC",
        "geonameId": 2078138,
        "south": -10.5704829995,
        "isoAlpha3": "CXR",
        "north": -10.412356007,
        "fipscode": "KT",
        "population": "1500",
        "east": 105.712596992,
        "isoNumeric": "162",
        "areaInSqKm": "135.0",
        "countrycode": "CX",
        "west": 105.533276992,
        "countryName": "Christmas Island",
        "continentName": "Oceania",
        "currencycode": "AUD"
    },
    {
        "continent": "EU",
        "capital": "Nicosia",
        "languages": "el-CY,tr-CY,en",
        "geonameId": 146669,
        "south": 34.6332846722908,
        "isoAlpha3": "CYP",
        "north": 35.701527,
        "fipscode": "CY",
        "population": "1102677",
        "east": 34.59791599999994,
        "isoNumeric": "196",
        "areaInSqKm": "9250.0",
        "countrycode": "CY",
        "west": 32.27308300000004,
        "countryName": "Cyprus",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Prague",
        "languages": "cs,sk",
        "geonameId": 3077311,
        "south": 48.551892864201,
        "isoAlpha3": "CZE",
        "north": 51.0557782422661,
        "fipscode": "EZ",
        "population": "10476000",
        "east": 18.8592743799298,
        "isoNumeric": "203",
        "areaInSqKm": "78866.0",
        "countrycode": "CZ",
        "west": 12.0906691601139,
        "countryName": "Czechia",
        "continentName": "Europe",
        "currencycode": "CZK"
    },
    {
        "continent": "EU",
        "capital": "Berlin",
        "languages": "de",
        "geonameId": 2921044,
        "south": 47.2701236047002,
        "isoAlpha3": "DEU",
        "north": 55.0583836008072,
        "fipscode": "GM",
        "population": "81802257",
        "east": 15.0418156516163,
        "isoNumeric": "276",
        "areaInSqKm": "357021.0",
        "countrycode": "DE",
        "west": 5.8663152683722,
        "countryName": "Germany",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Djibouti",
        "languages": "fr-DJ,ar,so-DJ,aa",
        "geonameId": 223816,
        "south": 10.9129530000001,
        "isoAlpha3": "DJI",
        "north": 12.7136967920001,
        "fipscode": "DJ",
        "population": "740528",
        "east": 43.4175099920001,
        "isoNumeric": "262",
        "areaInSqKm": "23000.0",
        "countrycode": "DJ",
        "west": 41.7708460000001,
        "countryName": "Djibouti",
        "continentName": "Africa",
        "currencycode": "DJF"
    },
    {
        "continent": "EU",
        "capital": "Copenhagen",
        "languages": "da-DK,en,fo,de-DK",
        "geonameId": 2623032,
        "south": 54.562389,
        "isoAlpha3": "DNK",
        "north": 57.748417,
        "fipscode": "DA",
        "population": "5484000",
        "east": 15.158834,
        "isoNumeric": "208",
        "areaInSqKm": "43094.0",
        "countrycode": "DK",
        "west": 8.075611,
        "countryName": "Denmark",
        "continentName": "Europe",
        "currencycode": "DKK"
    },
    {
        "continent": "NA",
        "capital": "Roseau",
        "languages": "en-DM",
        "geonameId": 3575830,
        "south": 15.206540651392563,
        "isoAlpha3": "DMA",
        "north": 15.639901700674933,
        "fipscode": "DO",
        "population": "72813",
        "east": -61.241630129651185,
        "isoNumeric": "212",
        "areaInSqKm": "754.0",
        "countrycode": "DM",
        "west": -61.4808292002466,
        "countryName": "Dominica",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "NA",
        "capital": "Santo Domingo",
        "languages": "es-DO",
        "geonameId": 3508796,
        "south": 17.5395066830409,
        "isoAlpha3": "DOM",
        "north": 19.9321257501267,
        "fipscode": "DR",
        "population": "9823821",
        "east": -68.3229591969468,
        "isoNumeric": "214",
        "areaInSqKm": "48730.0",
        "countrycode": "DO",
        "west": -72.0114723981787,
        "countryName": "Dominican Republic",
        "continentName": "North America",
        "currencycode": "DOP"
    },
    {
        "continent": "AF",
        "capital": "Algiers",
        "languages": "ar-DZ",
        "geonameId": 2589581,
        "south": 18.968147,
        "isoAlpha3": "DZA",
        "north": 37.089801381,
        "fipscode": "AG",
        "population": "34586184",
        "east": 11.9984999060001,
        "isoNumeric": "012",
        "areaInSqKm": "2381740.0",
        "countrycode": "DZ",
        "west": -8.66761116299995,
        "countryName": "Algeria",
        "continentName": "Africa",
        "currencycode": "DZD"
    },
    {
        "continent": "SA",
        "capital": "Quito",
        "languages": "es-EC",
        "geonameId": 3658394,
        "south": -5.01615732302488,
        "isoAlpha3": "ECU",
        "north": 1.43523516349953,
        "fipscode": "EC",
        "population": "14790608",
        "east": -75.1871465547501,
        "isoNumeric": "218",
        "areaInSqKm": "283560.0",
        "countrycode": "EC",
        "west": -81.0836838953894,
        "countryName": "Ecuador",
        "continentName": "South America",
        "currencycode": "USD"
    },
    {
        "continent": "EU",
        "capital": "Tallinn",
        "languages": "et,ru",
        "geonameId": 453733,
        "south": 57.5093097920079,
        "isoAlpha3": "EST",
        "north": 59.6753143130129,
        "fipscode": "EN",
        "population": "1291170",
        "east": 28.2090381531431,
        "isoNumeric": "233",
        "areaInSqKm": "45226.0",
        "countrycode": "EE",
        "west": 21.8285886498081,
        "countryName": "Estonia",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Cairo",
        "languages": "ar-EG,en,fr",
        "geonameId": 357994,
        "south": 21.724952,
        "isoAlpha3": "EGY",
        "north": 31.6709930000001,
        "fipscode": "EG",
        "population": "80471869",
        "east": 35.7935441020001,
        "isoNumeric": "818",
        "areaInSqKm": "1001450.0",
        "countrycode": "EG",
        "west": 24.6967750000001,
        "countryName": "Egypt",
        "continentName": "Africa",
        "currencycode": "EGP"
    },
    {
        "continent": "AF",
        "capital": "Laâyoune / El Aaiún",
        "languages": "ar,mey",
        "geonameId": 2461445,
        "south": 20.774158,
        "isoAlpha3": "ESH",
        "north": 27.669674,
        "fipscode": "WI",
        "population": "273008",
        "east": -8.670276,
        "isoNumeric": "732",
        "areaInSqKm": "266000.0",
        "countrycode": "EH",
        "west": -17.103182,
        "countryName": "Western Sahara",
        "continentName": "Africa",
        "currencycode": "MAD"
    },
    {
        "continent": "AF",
        "capital": "Asmara",
        "languages": "aa-ER,ar,tig,kun,ti-ER",
        "geonameId": 338010,
        "south": 12.359555,
        "isoAlpha3": "ERI",
        "north": 18.003084,
        "fipscode": "ER",
        "population": "5792984",
        "east": 43.13464,
        "isoNumeric": "232",
        "areaInSqKm": "121320.0",
        "countrycode": "ER",
        "west": 36.438778,
        "countryName": "Eritrea",
        "continentName": "Africa",
        "currencycode": "ERN"
    },
    {
        "continent": "EU",
        "capital": "Madrid",
        "languages": "es-ES,ca,gl,eu,oc",
        "geonameId": 2510769,
        "south": 36.0001044260548,
        "isoAlpha3": "ESP",
        "north": 43.7913565913767,
        "fipscode": "SP",
        "population": "46505963",
        "east": 4.32778473043961,
        "isoNumeric": "724",
        "areaInSqKm": "504782.0",
        "countrycode": "ES",
        "west": -9.30151567231899,
        "countryName": "Spain",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Addis Ababa",
        "languages": "am,en-ET,om-ET,ti-ET,so-ET,sid",
        "geonameId": 337996,
        "south": 3.40413700100004,
        "isoAlpha3": "ETH",
        "north": 14.894214,
        "fipscode": "ET",
        "population": "88013491",
        "east": 48.0010560010001,
        "isoNumeric": "231",
        "areaInSqKm": "1127127.0",
        "countrycode": "ET",
        "west": 32.997734001,
        "countryName": "Ethiopia",
        "continentName": "Africa",
        "currencycode": "ETB"
    },
    {
        "continent": "EU",
        "capital": "Helsinki",
        "languages": "fi-FI,sv-FI,smn",
        "geonameId": 660013,
        "south": 59.808777,
        "isoAlpha3": "FIN",
        "north": 70.096054,
        "fipscode": "FI",
        "population": "5244000",
        "east": 31.580944,
        "isoNumeric": "246",
        "areaInSqKm": "337030.0",
        "countrycode": "FI",
        "west": 20.556944,
        "countryName": "Finland",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "OC",
        "capital": "Suva",
        "languages": "en-FJ,fj",
        "geonameId": 2205218,
        "south": -20.67597,
        "isoAlpha3": "FJI",
        "north": -12.479632058714332,
        "fipscode": "FJ",
        "population": "875983",
        "east": -178.424438,
        "isoNumeric": "242",
        "areaInSqKm": "18270.0",
        "countrycode": "FJ",
        "west": 177.14038537647912,
        "countryName": "Fiji",
        "continentName": "Oceania",
        "currencycode": "FJD"
    },
    {
        "continent": "SA",
        "capital": "Stanley",
        "languages": "en-FK",
        "geonameId": 3474414,
        "south": -52.383984175,
        "isoAlpha3": "FLK",
        "north": -51.2331394719999,
        "fipscode": "FK",
        "population": "2638",
        "east": -57.718087652,
        "isoNumeric": "238",
        "areaInSqKm": "12173.0",
        "countrycode": "FK",
        "west": -61.3474566739999,
        "countryName": "Falkland Islands",
        "continentName": "South America",
        "currencycode": "FKP"
    },
    {
        "continent": "OC",
        "capital": "Palikir",
        "languages": "en-FM,chk,pon,yap,kos,uli,woe,nkr,kpg",
        "geonameId": 2081918,
        "south": 1.02629,
        "isoAlpha3": "FSM",
        "north": 10.08904,
        "fipscode": "FM",
        "population": "107708",
        "east": 163.03717,
        "isoNumeric": "583",
        "areaInSqKm": "702.0",
        "countrycode": "FM",
        "west": 137.33648,
        "countryName": "Micronesia",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "EU",
        "capital": "Tórshavn",
        "languages": "fo,da-FO",
        "geonameId": 2622320,
        "south": 61.3910302656013,
        "isoAlpha3": "FRO",
        "north": 62.3938884414274,
        "fipscode": "FO",
        "population": "48228",
        "east": -6.25655957192113,
        "isoNumeric": "234",
        "areaInSqKm": "1399.0",
        "countrycode": "FO",
        "west": -7.688191677774624,
        "countryName": "Faroe Islands",
        "continentName": "Europe",
        "currencycode": "DKK"
    },
    {
        "continent": "EU",
        "capital": "Paris",
        "languages": "fr-FR,frp,br,co,ca,eu,oc",
        "geonameId": 3017382,
        "south": 41.3658213299999,
        "isoAlpha3": "FRA",
        "north": 51.0890012279322,
        "fipscode": "FR",
        "population": "64768389",
        "east": 9.5596148665824,
        "isoNumeric": "250",
        "areaInSqKm": "547030.0",
        "countrycode": "FR",
        "west": -5.1389964684508,
        "countryName": "France",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Libreville",
        "languages": "fr-GA",
        "geonameId": 2400553,
        "south": -3.96180775999994,
        "isoAlpha3": "GAB",
        "north": 2.31810900100004,
        "fipscode": "GB",
        "population": "1545255",
        "east": 14.5269230000001,
        "isoNumeric": "266",
        "areaInSqKm": "267667.0",
        "countrycode": "GA",
        "west": 8.69940944700005,
        "countryName": "Gabon",
        "continentName": "Africa",
        "currencycode": "XAF"
    },
    {
        "continent": "EU",
        "capital": "London",
        "languages": "en-GB,cy-GB,gd",
        "geonameId": 2635167,
        "south": 49.9028622252397,
        "isoAlpha3": "GBR",
        "north": 59.3607741849963,
        "fipscode": "UK",
        "population": "62348447",
        "east": 1.7689121033873,
        "isoNumeric": "826",
        "areaInSqKm": "244820.0",
        "countrycode": "GB",
        "west": -8.61772077108559,
        "countryName": "United Kingdom",
        "continentName": "Europe",
        "currencycode": "GBP"
    },
    {
        "continent": "NA",
        "capital": "St. George's",
        "languages": "en-GD",
        "geonameId": 3580239,
        "south": 11.986893,
        "isoAlpha3": "GRD",
        "north": 12.318283928171299,
        "fipscode": "GJ",
        "population": "107818",
        "east": -61.57676970108031,
        "isoNumeric": "308",
        "areaInSqKm": "344.0",
        "countrycode": "GD",
        "west": -61.802344,
        "countryName": "Grenada",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "AS",
        "capital": "Tbilisi",
        "languages": "ka,ru,hy,az",
        "geonameId": 614540,
        "south": 41.054942,
        "isoAlpha3": "GEO",
        "north": 43.5866270000001,
        "fipscode": "GG",
        "population": "4630000",
        "east": 46.736119,
        "isoNumeric": "268",
        "areaInSqKm": "69700.0",
        "countrycode": "GE",
        "west": 40.006604,
        "countryName": "Georgia",
        "continentName": "Asia",
        "currencycode": "GEL"
    },
    {
        "continent": "SA",
        "capital": "Cayenne",
        "languages": "fr-GF",
        "geonameId": 3381670,
        "south": 2.127094,
        "isoAlpha3": "GUF",
        "north": 5.776496,
        "fipscode": "FG",
        "population": "195506",
        "east": -51.613949,
        "isoNumeric": "254",
        "areaInSqKm": "91000.0",
        "countrycode": "GF",
        "west": -54.542511,
        "countryName": "French Guiana",
        "continentName": "South America",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "St Peter Port",
        "languages": "en,nrf",
        "geonameId": 3042362,
        "south": 49.40764156876899,
        "isoAlpha3": "GGY",
        "north": 49.731727816705416,
        "fipscode": "GK",
        "population": "65228",
        "east": -2.1577152112246267,
        "isoNumeric": "831",
        "areaInSqKm": "78.0",
        "countrycode": "GG",
        "west": -2.673194593476069,
        "countryName": "Guernsey",
        "continentName": "Europe",
        "currencycode": "GBP"
    },
    {
        "continent": "AF",
        "capital": "Accra",
        "languages": "en-GH,ak,ee,tw",
        "geonameId": 2300660,
        "south": 4.73894544800004,
        "isoAlpha3": "GHA",
        "north": 11.174952907,
        "fipscode": "GH",
        "population": "24339838",
        "east": 1.19948138100006,
        "isoNumeric": "288",
        "areaInSqKm": "239460.0",
        "countrycode": "GH",
        "west": -3.26078599999994,
        "countryName": "Ghana",
        "continentName": "Africa",
        "currencycode": "GHS"
    },
    {
        "continent": "EU",
        "capital": "Gibraltar",
        "languages": "en-GI,es,it,pt",
        "geonameId": 2411586,
        "south": 36.10903070140248,
        "isoAlpha3": "GIB",
        "north": 36.155439135670726,
        "fipscode": "GI",
        "population": "27884",
        "east": -5.338285164001491,
        "isoNumeric": "292",
        "areaInSqKm": "6.5",
        "countrycode": "GI",
        "west": -5.36626149743654,
        "countryName": "Gibraltar",
        "continentName": "Europe",
        "currencycode": "GIP"
    },
    {
        "continent": "NA",
        "capital": "Nuuk",
        "languages": "kl,da-GL,en",
        "geonameId": 3425505,
        "south": 59.777401,
        "isoAlpha3": "GRL",
        "north": 83.627357,
        "fipscode": "GL",
        "population": "56375",
        "east": -11.312319,
        "isoNumeric": "304",
        "areaInSqKm": "2166086.0",
        "countrycode": "GL",
        "west": -73.04203,
        "countryName": "Greenland",
        "continentName": "North America",
        "currencycode": "DKK"
    },
    {
        "continent": "AF",
        "capital": "Bathurst",
        "languages": "en-GM,mnk,wof,wo,ff",
        "geonameId": 2413451,
        "south": 13.063718062,
        "isoAlpha3": "GMB",
        "north": 13.825058106,
        "fipscode": "GA",
        "population": "1593256",
        "east": -13.791386179,
        "isoNumeric": "270",
        "areaInSqKm": "11300.0",
        "countrycode": "GM",
        "west": -16.8136100139999,
        "countryName": "Gambia",
        "continentName": "Africa",
        "currencycode": "GMD"
    },
    {
        "continent": "AF",
        "capital": "Conakry",
        "languages": "fr-GN",
        "geonameId": 2420477,
        "south": 7.193553,
        "isoAlpha3": "GIN",
        "north": 12.67622,
        "fipscode": "GV",
        "population": "10324025",
        "east": -7.641071,
        "isoNumeric": "324",
        "areaInSqKm": "245857.0",
        "countrycode": "GN",
        "west": -14.926619,
        "countryName": "Guinea",
        "continentName": "Africa",
        "currencycode": "GNF"
    },
    {
        "continent": "NA",
        "capital": "Basse-Terre",
        "languages": "fr-GP",
        "geonameId": 3579143,
        "south": 15.867565,
        "isoAlpha3": "GLP",
        "north": 16.516848,
        "fipscode": "GP",
        "population": "443000",
        "east": -61,
        "isoNumeric": "312",
        "areaInSqKm": "1780.0",
        "countrycode": "GP",
        "west": -61.544765,
        "countryName": "Guadeloupe",
        "continentName": "North America",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Malabo",
        "languages": "es-GQ,fr",
        "geonameId": 2309096,
        "south": 0.92086,
        "isoAlpha3": "GNQ",
        "north": 2.346989,
        "fipscode": "EK",
        "population": "1014999",
        "east": 11.335724,
        "isoNumeric": "226",
        "areaInSqKm": "28051.0",
        "countrycode": "GQ",
        "west": 9.346865,
        "countryName": "Equatorial Guinea",
        "continentName": "Africa",
        "currencycode": "XAF"
    },
    {
        "continent": "EU",
        "capital": "Athens",
        "languages": "el-GR,en,fr",
        "geonameId": 390903,
        "south": 34.8020663391466,
        "isoAlpha3": "GRC",
        "north": 41.7484999849641,
        "fipscode": "GR",
        "population": "11000000",
        "east": 28.2470831714347,
        "isoNumeric": "300",
        "areaInSqKm": "131940.0",
        "countrycode": "GR",
        "west": 19.3736035624134,
        "countryName": "Greece",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AN",
        "capital": "Grytviken",
        "languages": "en",
        "geonameId": 3474415,
        "south": -59.46319341,
        "isoAlpha3": "SGS",
        "north": -53.980896636,
        "fipscode": "SX",
        "population": "30",
        "east": -26.252069712,
        "isoNumeric": "239",
        "areaInSqKm": "3903.0",
        "countrycode": "GS",
        "west": -38.0479509639999,
        "countryName": "South Georgia and the South Sandwich Islands",
        "continentName": "Antarctica",
        "currencycode": "GBP"
    },
    {
        "continent": "NA",
        "capital": "Guatemala City",
        "languages": "es-GT",
        "geonameId": 3595528,
        "south": 13.7400210010001,
        "isoAlpha3": "GTM",
        "north": 17.815695169,
        "fipscode": "GT",
        "population": "13550440",
        "east": -88.233001934,
        "isoNumeric": "320",
        "areaInSqKm": "108890.0",
        "countrycode": "GT",
        "west": -92.231143101,
        "countryName": "Guatemala",
        "continentName": "North America",
        "currencycode": "GTQ"
    },
    {
        "continent": "OC",
        "capital": "Hagåtña",
        "languages": "en-GU,ch-GU",
        "geonameId": 4043988,
        "south": 13.23376,
        "isoAlpha3": "GUM",
        "north": 13.654402,
        "fipscode": "GQ",
        "population": "159358",
        "east": 144.956894,
        "isoNumeric": "316",
        "areaInSqKm": "549.0",
        "countrycode": "GU",
        "west": 144.618318,
        "countryName": "Guam",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "AF",
        "capital": "Bissau",
        "languages": "pt-GW,pov",
        "geonameId": 2372248,
        "south": 10.924265,
        "isoAlpha3": "GNB",
        "north": 12.680789,
        "fipscode": "PU",
        "population": "1565126",
        "east": -13.636522,
        "isoNumeric": "624",
        "areaInSqKm": "36120.0",
        "countrycode": "GW",
        "west": -16.717535,
        "countryName": "Guinea-Bissau",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "SA",
        "capital": "Georgetown",
        "languages": "en-GY",
        "geonameId": 3378535,
        "south": 1.17508,
        "isoAlpha3": "GUY",
        "north": 8.557567,
        "fipscode": "GY",
        "population": "748486",
        "east": -56.480251,
        "isoNumeric": "328",
        "areaInSqKm": "214970.0",
        "countrycode": "GY",
        "west": -61.384762,
        "countryName": "Guyana",
        "continentName": "South America",
        "currencycode": "GYD"
    },
    {
        "continent": "AS",
        "capital": "Hong Kong",
        "languages": "zh-HK,yue,zh,en",
        "geonameId": 1819730,
        "south": 22.15325,
        "isoAlpha3": "HKG",
        "north": 22.559778,
        "fipscode": "HK",
        "population": "6898686",
        "east": 114.434753,
        "isoNumeric": "344",
        "areaInSqKm": "1092.0",
        "countrycode": "HK",
        "west": 113.837753,
        "countryName": "Hong Kong",
        "continentName": "Asia",
        "currencycode": "HKD"
    },
    {
        "continent": "AN",
        "capital": "",
        "languages": "",
        "geonameId": 1547314,
        "south": -53.192001,
        "isoAlpha3": "HMD",
        "north": -52.909416,
        "fipscode": "HM",
        "population": "0",
        "east": 73.859146,
        "isoNumeric": "334",
        "areaInSqKm": "412.0",
        "countrycode": "HM",
        "west": 72.596535,
        "countryName": "Heard Island and McDonald Islands",
        "continentName": "Antarctica",
        "currencycode": "AUD"
    },
    {
        "continent": "NA",
        "capital": "Tegucigalpa",
        "languages": "es-HN,cab,miq",
        "geonameId": 3608932,
        "south": 12.982411,
        "isoAlpha3": "HND",
        "north": 16.510256,
        "fipscode": "HO",
        "population": "7989415",
        "east": -83.155403,
        "isoNumeric": "340",
        "areaInSqKm": "112090.0",
        "countrycode": "HN",
        "west": -89.350792,
        "countryName": "Honduras",
        "continentName": "North America",
        "currencycode": "HNL"
    },
    {
        "continent": "EU",
        "capital": "Zagreb",
        "languages": "hr-HR,sr",
        "geonameId": 3202326,
        "south": 42.43589,
        "isoAlpha3": "HRV",
        "north": 46.5549629558487,
        "fipscode": "HR",
        "population": "4284889",
        "east": 19.427389,
        "isoNumeric": "191",
        "areaInSqKm": "56542.0",
        "countrycode": "HR",
        "west": 13.493222,
        "countryName": "Croatia",
        "continentName": "Europe",
        "currencycode": "HRK"
    },
    {
        "continent": "NA",
        "capital": "Port-au-Prince",
        "languages": "ht,fr-HT",
        "geonameId": 3723988,
        "south": 18.021032,
        "isoAlpha3": "HTI",
        "north": 20.08782,
        "fipscode": "HA",
        "population": "9648924",
        "east": -71.613358,
        "isoNumeric": "332",
        "areaInSqKm": "27750.0",
        "countrycode": "HT",
        "west": -74.478584,
        "countryName": "Haiti",
        "continentName": "North America",
        "currencycode": "HTG"
    },
    {
        "continent": "EU",
        "capital": "Budapest",
        "languages": "hu-HU",
        "geonameId": 719819,
        "south": 45.7370495590001,
        "isoAlpha3": "HUN",
        "north": 48.585336,
        "fipscode": "HU",
        "population": "9982000",
        "east": 22.896564336,
        "isoNumeric": "348",
        "areaInSqKm": "93030.0",
        "countrycode": "HU",
        "west": 16.113795,
        "countryName": "Hungary",
        "continentName": "Europe",
        "currencycode": "HUF"
    },
    {
        "continent": "AS",
        "capital": "Jakarta",
        "languages": "id,en,nl,jv",
        "geonameId": 1643084,
        "south": -10.941861,
        "isoAlpha3": "IDN",
        "north": 5.904417,
        "fipscode": "ID",
        "population": "242968342",
        "east": 141.021805,
        "isoNumeric": "360",
        "areaInSqKm": "1919440.0",
        "countrycode": "ID",
        "west": 95.009331,
        "countryName": "Indonesia",
        "continentName": "Asia",
        "currencycode": "IDR"
    },
    {
        "continent": "EU",
        "capital": "Dublin",
        "languages": "en-IE,ga-IE",
        "geonameId": 2963597,
        "south": 51.4475491577615,
        "isoAlpha3": "IRL",
        "north": 55.3829431564742,
        "fipscode": "EI",
        "population": "4622917",
        "east": -5.99804990172185,
        "isoNumeric": "372",
        "areaInSqKm": "70280.0",
        "countrycode": "IE",
        "west": -10.4800035816853,
        "countryName": "Ireland",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AS",
        "capital": "",
        "languages": "he,ar-IL,en-IL,",
        "geonameId": 294640,
        "south": 29.490654862,
        "isoAlpha3": "ISR",
        "north": 33.2908350000001,
        "fipscode": "IS",
        "population": "7353985",
        "east": 35.67033,
        "isoNumeric": "376",
        "areaInSqKm": "20770.0",
        "countrycode": "IL",
        "west": 34.267257,
        "countryName": "Israel",
        "continentName": "Asia",
        "currencycode": "ILS"
    },
    {
        "continent": "EU",
        "capital": "Douglas",
        "languages": "en,gv",
        "geonameId": 3042225,
        "south": 54.055916,
        "isoAlpha3": "IMN",
        "north": 54.419724,
        "fipscode": "IM",
        "population": "75049",
        "east": -4.3115,
        "isoNumeric": "833",
        "areaInSqKm": "572.0",
        "countrycode": "IM",
        "west": -4.798722,
        "countryName": "Isle of Man",
        "continentName": "Europe",
        "currencycode": "GBP"
    },
    {
        "continent": "AS",
        "capital": "New Delhi",
        "languages": "en-IN,hi,bn,te,mr,ta,ur,gu,kn,ml,or,pa,as,bh,sat,ks,ne,sd,kok,doi,mni,sit,sa,fr,lus,inc",
        "geonameId": 1269750,
        "south": 6.7559528993543,
        "isoAlpha3": "IND",
        "north": 35.524548272882,
        "fipscode": "IN",
        "population": "1173108018",
        "east": 97.4152926679075,
        "isoNumeric": "356",
        "areaInSqKm": "3287590.0",
        "countrycode": "IN",
        "west": 68.4840183183648,
        "countryName": "India",
        "continentName": "Asia",
        "currencycode": "INR"
    },
    {
        "continent": "AS",
        "capital": "",
        "languages": "en-IO",
        "geonameId": 1282588,
        "south": -7.438028,
        "isoAlpha3": "IOT",
        "north": -5.268333,
        "fipscode": "IO",
        "population": "4000",
        "east": 72.493164,
        "isoNumeric": "086",
        "areaInSqKm": "60.0",
        "countrycode": "IO",
        "west": 71.259972,
        "countryName": "British Indian Ocean Territory",
        "continentName": "Asia",
        "currencycode": "USD"
    },
    {
        "continent": "AS",
        "capital": "Baghdad",
        "languages": "ar-IQ,ku,hy",
        "geonameId": 99237,
        "south": 29.0612080000001,
        "isoAlpha3": "IRQ",
        "north": 37.380746001,
        "fipscode": "IZ",
        "population": "29671605",
        "east": 48.6117360000001,
        "isoNumeric": "368",
        "areaInSqKm": "437072.0",
        "countrycode": "IQ",
        "west": 38.7936740000001,
        "countryName": "Iraq",
        "continentName": "Asia",
        "currencycode": "IQD"
    },
    {
        "continent": "AS",
        "capital": "Tehran",
        "languages": "fa-IR,ku",
        "geonameId": 130758,
        "south": 25.064083,
        "isoAlpha3": "IRN",
        "north": 39.777222,
        "fipscode": "IR",
        "population": "76923300",
        "east": 63.317471,
        "isoNumeric": "364",
        "areaInSqKm": "1648000.0",
        "countrycode": "IR",
        "west": 44.047279,
        "countryName": "Iran",
        "continentName": "Asia",
        "currencycode": "IRR"
    },
    {
        "continent": "EU",
        "capital": "Reykjavik",
        "languages": "is,en,de,da,sv,no",
        "geonameId": 2629691,
        "south": 63.394392778588,
        "isoAlpha3": "ISL",
        "north": 66.5377933098397,
        "fipscode": "IC",
        "population": "308910",
        "east": -13.4946206239501,
        "isoNumeric": "352",
        "areaInSqKm": "103000.0",
        "countrycode": "IS",
        "west": -24.5326753866625,
        "countryName": "Iceland",
        "continentName": "Europe",
        "currencycode": "ISK"
    },
    {
        "continent": "EU",
        "capital": "Rome",
        "languages": "it-IT,de-IT,fr-IT,sc,ca,co,sl",
        "geonameId": 3175395,
        "south": 36.6440816661648,
        "isoAlpha3": "ITA",
        "north": 47.0917837415439,
        "fipscode": "IT",
        "population": "60340328",
        "east": 18.5203814091888,
        "isoNumeric": "380",
        "areaInSqKm": "301230.0",
        "countrycode": "IT",
        "west": 6.62662135986088,
        "countryName": "Italy",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Saint Helier",
        "languages": "en,fr,nrf",
        "geonameId": 3042142,
        "south": 49.169834,
        "isoAlpha3": "JEY",
        "north": 49.265057,
        "fipscode": "JE",
        "population": "90812",
        "east": -2.022083,
        "isoNumeric": "832",
        "areaInSqKm": "116.0",
        "countrycode": "JE",
        "west": -2.260028,
        "countryName": "Jersey",
        "continentName": "Europe",
        "currencycode": "GBP"
    },
    {
        "continent": "NA",
        "capital": "Kingston",
        "languages": "en-JM",
        "geonameId": 3489940,
        "south": 17.7059966193696,
        "isoAlpha3": "JAM",
        "north": 18.524766185516,
        "fipscode": "JM",
        "population": "2847232",
        "east": -76.1830989848426,
        "isoNumeric": "388",
        "areaInSqKm": "10991.0",
        "countrycode": "JM",
        "west": -78.3690062954957,
        "countryName": "Jamaica",
        "continentName": "North America",
        "currencycode": "JMD"
    },
    {
        "continent": "AS",
        "capital": "Amman",
        "languages": "ar-JO,en",
        "geonameId": 248816,
        "south": 29.1850360010001,
        "isoAlpha3": "JOR",
        "north": 33.374735,
        "fipscode": "JO",
        "population": "6407085",
        "east": 39.3011540000001,
        "isoNumeric": "400",
        "areaInSqKm": "92300.0",
        "countrycode": "JO",
        "west": 34.955471039,
        "countryName": "Jordan",
        "continentName": "Asia",
        "currencycode": "JOD"
    },
    {
        "continent": "AS",
        "capital": "Tokyo",
        "languages": "ja",
        "geonameId": 1861060,
        "south": 24.255169441,
        "isoAlpha3": "JPN",
        "north": 45.52295736,
        "fipscode": "JA",
        "population": "127288000",
        "east": 145.817458885,
        "isoNumeric": "392",
        "areaInSqKm": "377835.0",
        "countrycode": "JP",
        "west": 122.933653061,
        "countryName": "Japan",
        "continentName": "Asia",
        "currencycode": "JPY"
    },
    {
        "continent": "AF",
        "capital": "Nairobi",
        "languages": "en-KE,sw-KE",
        "geonameId": 192950,
        "south": -4.67989449199996,
        "isoAlpha3": "KEN",
        "north": 5.03342100100002,
        "fipscode": "KE",
        "population": "40046566",
        "east": 41.9069450000001,
        "isoNumeric": "404",
        "areaInSqKm": "582650.0",
        "countrycode": "KE",
        "west": 33.9098210000001,
        "countryName": "Kenya",
        "continentName": "Africa",
        "currencycode": "KES"
    },
    {
        "continent": "AS",
        "capital": "Bishkek",
        "languages": "ky,uz,ru",
        "geonameId": 1527747,
        "south": 39.172832,
        "isoAlpha3": "KGZ",
        "north": 43.238224,
        "fipscode": "KG",
        "population": "5776500",
        "east": 80.283165,
        "isoNumeric": "417",
        "areaInSqKm": "198500.0",
        "countrycode": "KG",
        "west": 69.276611,
        "countryName": "Kyrgyzstan",
        "continentName": "Asia",
        "currencycode": "KGS"
    },
    {
        "continent": "AS",
        "capital": "Phnom Penh",
        "languages": "km,fr,en",
        "geonameId": 1831722,
        "south": 10.409083,
        "isoAlpha3": "KHM",
        "north": 14.686417,
        "fipscode": "CB",
        "population": "14453680",
        "east": 107.627724,
        "isoNumeric": "116",
        "areaInSqKm": "181040.0",
        "countrycode": "KH",
        "west": 102.339996,
        "countryName": "Cambodia",
        "continentName": "Asia",
        "currencycode": "KHR"
    },
    {
        "continent": "OC",
        "capital": "Tarawa",
        "languages": "en-KI,gil",
        "geonameId": 4030945,
        "south": -11.446881150186856,
        "isoAlpha3": "KIR",
        "north": 4.71957,
        "fipscode": "KR",
        "population": "92533",
        "east": -150.215347,
        "isoNumeric": "296",
        "areaInSqKm": "811.0",
        "countrycode": "KI",
        "west": 169.556137,
        "countryName": "Kiribati",
        "continentName": "Oceania",
        "currencycode": "AUD"
    },
    {
        "continent": "AF",
        "capital": "Moroni",
        "languages": "ar,fr-KM",
        "geonameId": 921929,
        "south": -12.387857,
        "isoAlpha3": "COM",
        "north": -11.362381,
        "fipscode": "CN",
        "population": "773407",
        "east": 44.538223,
        "isoNumeric": "174",
        "areaInSqKm": "2170.0",
        "countrycode": "KM",
        "west": 43.21579,
        "countryName": "Comoros",
        "continentName": "Africa",
        "currencycode": "KMF"
    },
    {
        "continent": "NA",
        "capital": "Basseterre",
        "languages": "en-KN",
        "geonameId": 3575174,
        "south": 17.094276497441214,
        "isoAlpha3": "KNA",
        "north": 17.418152531334183,
        "fipscode": "SC",
        "population": "51134",
        "east": -62.53964136573717,
        "isoNumeric": "659",
        "areaInSqKm": "261.0",
        "countrycode": "KN",
        "west": -62.86483931213377,
        "countryName": "Saint Kitts and Nevis",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "AS",
        "capital": "Pyongyang",
        "languages": "ko-KP",
        "geonameId": 1873107,
        "south": 37.673332,
        "isoAlpha3": "PRK",
        "north": 43.006054,
        "fipscode": "KN",
        "population": "22912177",
        "east": 130.674866,
        "isoNumeric": "408",
        "areaInSqKm": "120540.0",
        "countrycode": "KP",
        "west": 124.315887,
        "countryName": "North Korea",
        "continentName": "Asia",
        "currencycode": "KPW"
    },
    {
        "continent": "AS",
        "capital": "Seoul",
        "languages": "ko-KR,en",
        "geonameId": 1835841,
        "south": 33.1954102977009,
        "isoAlpha3": "KOR",
        "north": 38.5933891092225,
        "fipscode": "KS",
        "population": "48422644",
        "east": 129.583016157998,
        "isoNumeric": "410",
        "areaInSqKm": "98480.0",
        "countrycode": "KR",
        "west": 125.887442375577,
        "countryName": "South Korea",
        "continentName": "Asia",
        "currencycode": "KRW"
    },
    {
        "continent": "AS",
        "capital": "Kuwait City",
        "languages": "ar-KW,en",
        "geonameId": 285570,
        "south": 28.524611,
        "isoAlpha3": "KWT",
        "north": 30.095945,
        "fipscode": "KU",
        "population": "2789132",
        "east": 48.431473,
        "isoNumeric": "414",
        "areaInSqKm": "17820.0",
        "countrycode": "KW",
        "west": 46.555557,
        "countryName": "Kuwait",
        "continentName": "Asia",
        "currencycode": "KWD"
    },
    {
        "continent": "NA",
        "capital": "George Town",
        "languages": "en-KY",
        "geonameId": 3580718,
        "south": 19.263029,
        "isoAlpha3": "CYM",
        "north": 19.7617,
        "fipscode": "CJ",
        "population": "44270",
        "east": -79.727272,
        "isoNumeric": "136",
        "areaInSqKm": "262.0",
        "countrycode": "KY",
        "west": -81.432777,
        "countryName": "Cayman Islands",
        "continentName": "North America",
        "currencycode": "KYD"
    },
    {
        "continent": "AS",
        "capital": "Astana",
        "languages": "kk,ru",
        "geonameId": 1522867,
        "south": 40.5686884990001,
        "isoAlpha3": "KAZ",
        "north": 55.441984001,
        "fipscode": "KZ",
        "population": "15340000",
        "east": 87.3154150010001,
        "isoNumeric": "398",
        "areaInSqKm": "2717300.0",
        "countrycode": "KZ",
        "west": 46.4936720000001,
        "countryName": "Kazakhstan",
        "continentName": "Asia",
        "currencycode": "KZT"
    },
    {
        "continent": "AS",
        "capital": "Vientiane",
        "languages": "lo,fr,en",
        "geonameId": 1655842,
        "south": 13.909720001,
        "isoAlpha3": "LAO",
        "north": 22.50904495,
        "fipscode": "LA",
        "population": "6368162",
        "east": 107.635093936,
        "isoNumeric": "418",
        "areaInSqKm": "236800.0",
        "countrycode": "LA",
        "west": 100.083872,
        "countryName": "Laos",
        "continentName": "Asia",
        "currencycode": "LAK"
    },
    {
        "continent": "AS",
        "capital": "Beirut",
        "languages": "ar-LB,fr-LB,en,hy",
        "geonameId": 272103,
        "south": 33.0550260000001,
        "isoAlpha3": "LBN",
        "north": 34.6920900000001,
        "fipscode": "LE",
        "population": "4125247",
        "east": 36.62372,
        "isoNumeric": "422",
        "areaInSqKm": "10400.0",
        "countrycode": "LB",
        "west": 35.103668213,
        "countryName": "Lebanon",
        "continentName": "Asia",
        "currencycode": "LBP"
    },
    {
        "continent": "NA",
        "capital": "Castries",
        "languages": "en-LC",
        "geonameId": 3576468,
        "south": 13.7072692224982,
        "isoAlpha3": "LCA",
        "north": 14.110317287646,
        "fipscode": "ST",
        "population": "160922",
        "east": -60.8732306422271,
        "isoNumeric": "662",
        "areaInSqKm": "616.0",
        "countrycode": "LC",
        "west": -61.07995730159752,
        "countryName": "Saint Lucia",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "EU",
        "capital": "Vaduz",
        "languages": "de-LI",
        "geonameId": 3042058,
        "south": 47.0484284123471,
        "isoAlpha3": "LIE",
        "north": 47.2706251386959,
        "fipscode": "LS",
        "population": "35000",
        "east": 9.63564281136796,
        "isoNumeric": "438",
        "areaInSqKm": "160.0",
        "countrycode": "LI",
        "west": 9.47167359782014,
        "countryName": "Liechtenstein",
        "continentName": "Europe",
        "currencycode": "CHF"
    },
    {
        "continent": "AS",
        "capital": "Colombo",
        "languages": "si,ta,en",
        "geonameId": 1227603,
        "south": 5.91869676126554,
        "isoAlpha3": "LKA",
        "north": 9.83586297688552,
        "fipscode": "CE",
        "population": "21513990",
        "east": 81.8790900303934,
        "isoNumeric": "144",
        "areaInSqKm": "65610.0",
        "countrycode": "LK",
        "west": 79.6505518289324,
        "countryName": "Sri Lanka",
        "continentName": "Asia",
        "currencycode": "LKR"
    },
    {
        "continent": "AF",
        "capital": "Monrovia",
        "languages": "en-LR",
        "geonameId": 2275384,
        "south": 4.35326143300006,
        "isoAlpha3": "LBR",
        "north": 8.55198600000006,
        "fipscode": "LI",
        "population": "3685076",
        "east": -7.36925499999995,
        "isoNumeric": "430",
        "areaInSqKm": "111370.0",
        "countrycode": "LR",
        "west": -11.4993114059999,
        "countryName": "Liberia",
        "continentName": "Africa",
        "currencycode": "LRD"
    },
    {
        "continent": "AF",
        "capital": "Maseru",
        "languages": "en-LS,st,zu,xh",
        "geonameId": 932692,
        "south": -30.6755750029999,
        "isoAlpha3": "LSO",
        "north": -28.5708,
        "fipscode": "LT",
        "population": "1919552",
        "east": 29.4557099420001,
        "isoNumeric": "426",
        "areaInSqKm": "30355.0",
        "countrycode": "LS",
        "west": 27.011229998,
        "countryName": "Lesotho",
        "continentName": "Africa",
        "currencycode": "LSL"
    },
    {
        "continent": "EU",
        "capital": "Vilnius",
        "languages": "lt,ru,pl",
        "geonameId": 597427,
        "south": 53.89679499,
        "isoAlpha3": "LTU",
        "north": 56.4504065100001,
        "fipscode": "LH",
        "population": "2944459",
        "east": 26.8355231,
        "isoNumeric": "440",
        "areaInSqKm": "65200.0",
        "countrycode": "LT",
        "west": 20.941528,
        "countryName": "Lithuania",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Luxembourg",
        "languages": "lb,de-LU,fr-LU",
        "geonameId": 2960313,
        "south": 49.447858677765716,
        "isoAlpha3": "LUX",
        "north": 50.182772453796446,
        "fipscode": "LU",
        "population": "497538",
        "east": 6.5308980672559525,
        "isoNumeric": "442",
        "areaInSqKm": "2586.0",
        "countrycode": "LU",
        "west": 5.735698938390786,
        "countryName": "Luxembourg",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Riga",
        "languages": "lv,ru,lt",
        "geonameId": 458258,
        "south": 55.6746669350001,
        "isoAlpha3": "LVA",
        "north": 58.085568788,
        "fipscode": "LG",
        "population": "2217969",
        "east": 28.241403,
        "isoNumeric": "428",
        "areaInSqKm": "64589.0",
        "countrycode": "LV",
        "west": 20.9691104890001,
        "countryName": "Latvia",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Tripoli",
        "languages": "ar-LY,it,en",
        "geonameId": 2215636,
        "south": 19.508045,
        "isoAlpha3": "LBY",
        "north": 33.168999,
        "fipscode": "LY",
        "population": "6461454",
        "east": 25.150612,
        "isoNumeric": "434",
        "areaInSqKm": "1759540.0",
        "countrycode": "LY",
        "west": 9.38702,
        "countryName": "Libya",
        "continentName": "Africa",
        "currencycode": "LYD"
    },
    {
        "continent": "AF",
        "capital": "Rabat",
        "languages": "ar-MA,ber,fr",
        "geonameId": 2542007,
        "south": 27.6672694750001,
        "isoAlpha3": "MAR",
        "north": 35.922341095,
        "fipscode": "MO",
        "population": "33848242",
        "east": -0.996975780999946,
        "isoNumeric": "504",
        "areaInSqKm": "446550.0",
        "countrycode": "MA",
        "west": -13.1722970399999,
        "countryName": "Morocco",
        "continentName": "Africa",
        "currencycode": "MAD"
    },
    {
        "continent": "EU",
        "capital": "Monaco",
        "languages": "fr-MC,en,it",
        "geonameId": 2993457,
        "south": 43.72472839869377,
        "isoAlpha3": "MCO",
        "north": 43.75196717037228,
        "fipscode": "MN",
        "population": "32965",
        "east": 7.439939260482788,
        "isoNumeric": "492",
        "areaInSqKm": "1.95",
        "countrycode": "MC",
        "west": 7.408962249755859,
        "countryName": "Monaco",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Chişinău",
        "languages": "ro,ru,gag,tr",
        "geonameId": 617790,
        "south": 45.4674379630001,
        "isoAlpha3": "MDA",
        "north": 48.492029003,
        "fipscode": "MD",
        "population": "4324000",
        "east": 30.1635900000001,
        "isoNumeric": "498",
        "areaInSqKm": "33843.0",
        "countrycode": "MD",
        "west": 26.6164249990001,
        "countryName": "Moldova",
        "continentName": "Europe",
        "currencycode": "MDL"
    },
    {
        "continent": "EU",
        "capital": "Podgorica",
        "languages": "sr,hu,bs,sq,hr,rom",
        "geonameId": 3194884,
        "south": 41.868751527,
        "isoAlpha3": "MNE",
        "north": 43.558230232,
        "fipscode": "MJ",
        "population": "666730",
        "east": 20.352926,
        "isoNumeric": "499",
        "areaInSqKm": "14026.0",
        "countrycode": "ME",
        "west": 18.4335595800001,
        "countryName": "Montenegro",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "NA",
        "capital": "Marigot",
        "languages": "fr",
        "geonameId": 3578421,
        "south": 18.04717219103021,
        "isoAlpha3": "MAF",
        "north": 18.125295191246206,
        "fipscode": "RN",
        "population": "35925",
        "east": -63.01059106320133,
        "isoNumeric": "663",
        "areaInSqKm": "53.0",
        "countrycode": "MF",
        "west": -63.15036103890611,
        "countryName": "Saint Martin",
        "continentName": "North America",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Antananarivo",
        "languages": "fr-MG,mg",
        "geonameId": 1062947,
        "south": -25.608952,
        "isoAlpha3": "MDG",
        "north": -11.945433,
        "fipscode": "MA",
        "population": "21281844",
        "east": 50.48378,
        "isoNumeric": "450",
        "areaInSqKm": "587040.0",
        "countrycode": "MG",
        "west": 43.224876,
        "countryName": "Madagascar",
        "continentName": "Africa",
        "currencycode": "MGA"
    },
    {
        "continent": "OC",
        "capital": "Majuro",
        "languages": "mh,en-MH",
        "geonameId": 2080185,
        "south": 5.587639,
        "isoAlpha3": "MHL",
        "north": 14.62,
        "fipscode": "RM",
        "population": "65859",
        "east": 171.931808,
        "isoNumeric": "584",
        "areaInSqKm": "181.3",
        "countrycode": "MH",
        "west": 165.524918,
        "countryName": "Marshall Islands",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "EU",
        "capital": "Skopje",
        "languages": "mk,sq,tr,rmm,sr",
        "geonameId": 718075,
        "south": 40.8539489400001,
        "isoAlpha3": "MKD",
        "north": 42.3736460000001,
        "fipscode": "MK",
        "population": "2062294",
        "east": 23.0340440310001,
        "isoNumeric": "807",
        "areaInSqKm": "25333.0",
        "countrycode": "MK",
        "west": 20.4524230000001,
        "countryName": "Macedonia",
        "continentName": "Europe",
        "currencycode": "MKD"
    },
    {
        "continent": "AF",
        "capital": "Bamako",
        "languages": "fr-ML,bm",
        "geonameId": 2453866,
        "south": 10.147811,
        "isoAlpha3": "MLI",
        "north": 25.001084,
        "fipscode": "ML",
        "population": "13796354",
        "east": 4.26666786900006,
        "isoNumeric": "466",
        "areaInSqKm": "1240000.0",
        "countrycode": "ML",
        "west": -12.240344643,
        "countryName": "Mali",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "AS",
        "capital": "Naypyitaw",
        "languages": "my",
        "geonameId": 1327865,
        "south": 9.784583,
        "isoAlpha3": "MMR",
        "north": 28.543249,
        "fipscode": "BM",
        "population": "53414374",
        "east": 101.176781,
        "isoNumeric": "104",
        "areaInSqKm": "678500.0",
        "countrycode": "MM",
        "west": 92.189278,
        "countryName": "Myanmar [Burma]",
        "continentName": "Asia",
        "currencycode": "MMK"
    },
    {
        "continent": "AS",
        "capital": "Ulan Bator",
        "languages": "mn,ru",
        "geonameId": 2029969,
        "south": 41.5818330000001,
        "isoAlpha3": "MNG",
        "north": 52.1483550020001,
        "fipscode": "MG",
        "population": "3086918",
        "east": 119.931509803,
        "isoNumeric": "496",
        "areaInSqKm": "1565000.0",
        "countrycode": "MN",
        "west": 87.7344790560001,
        "countryName": "Mongolia",
        "continentName": "Asia",
        "currencycode": "MNT"
    },
    {
        "continent": "AS",
        "capital": "Macao",
        "languages": "zh,zh-MO,pt",
        "geonameId": 1821275,
        "south": 22.179927465,
        "isoAlpha3": "MAC",
        "north": 22.2170590110001,
        "fipscode": "MC",
        "population": "449198",
        "east": 113.56087212,
        "isoNumeric": "446",
        "areaInSqKm": "254.0",
        "countrycode": "MO",
        "west": 113.528563856,
        "countryName": "Macao",
        "continentName": "Asia",
        "currencycode": "MOP"
    },
    {
        "continent": "OC",
        "capital": "Saipan",
        "languages": "fil,tl,zh,ch-MP,en-MP",
        "geonameId": 4041468,
        "south": 14.11023,
        "isoAlpha3": "MNP",
        "north": 20.55344,
        "fipscode": "CQ",
        "population": "53883",
        "east": 146.06528,
        "isoNumeric": "580",
        "areaInSqKm": "477.0",
        "countrycode": "MP",
        "west": 144.88626,
        "countryName": "Northern Mariana Islands",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "NA",
        "capital": "Fort-de-France",
        "languages": "fr-MQ",
        "geonameId": 3570311,
        "south": 14.3948095793821,
        "isoAlpha3": "MTQ",
        "north": 14.8793869227087,
        "fipscode": "MB",
        "population": "432900",
        "east": -60.80971372311262,
        "isoNumeric": "474",
        "areaInSqKm": "1100.0",
        "countrycode": "MQ",
        "west": -61.22906667943528,
        "countryName": "Martinique",
        "continentName": "North America",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Nouakchott",
        "languages": "ar-MR,fuc,snk,fr,mey,wo",
        "geonameId": 2378080,
        "south": 14.715547,
        "isoAlpha3": "MRT",
        "north": 27.298073,
        "fipscode": "MR",
        "population": "3205060",
        "east": -4.827674,
        "isoNumeric": "478",
        "areaInSqKm": "1030700.0",
        "countrycode": "MR",
        "west": -17.066521,
        "countryName": "Mauritania",
        "continentName": "Africa",
        "currencycode": "MRO"
    },
    {
        "continent": "NA",
        "capital": "Plymouth",
        "languages": "en-MS",
        "geonameId": 3578097,
        "south": 16.674768935441556,
        "isoAlpha3": "MSR",
        "north": 16.824060205313184,
        "fipscode": "MH",
        "population": "9341",
        "east": -62.144100129608205,
        "isoNumeric": "500",
        "areaInSqKm": "102.0",
        "countrycode": "MS",
        "west": -62.24138237036129,
        "countryName": "Montserrat",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "EU",
        "capital": "Valletta",
        "languages": "mt,en-MT",
        "geonameId": 2562770,
        "south": 35.8061835000002,
        "isoAlpha3": "MLT",
        "north": 36.0821530995456,
        "fipscode": "MT",
        "population": "403000",
        "east": 14.5764915000002,
        "isoNumeric": "470",
        "areaInSqKm": "316.0",
        "countrycode": "MT",
        "west": 14.1834251000001,
        "countryName": "Malta",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Port Louis",
        "languages": "en-MU,bho,fr",
        "geonameId": 934292,
        "south": -20.5255565639999,
        "isoAlpha3": "MUS",
        "north": -10.336483002,
        "fipscode": "MP",
        "population": "1294104",
        "east": 63.5028269640001,
        "isoNumeric": "480",
        "areaInSqKm": "2040.0",
        "countrycode": "MU",
        "west": 56.584918976,
        "countryName": "Mauritius",
        "continentName": "Africa",
        "currencycode": "MUR"
    },
    {
        "continent": "AS",
        "capital": "Malé",
        "languages": "dv,en",
        "geonameId": 1282028,
        "south": -0.692694,
        "isoAlpha3": "MDV",
        "north": 7.091587495414767,
        "fipscode": "MV",
        "population": "395650",
        "east": 73.637276,
        "isoNumeric": "462",
        "areaInSqKm": "300.0",
        "countrycode": "MV",
        "west": 72.693222,
        "countryName": "Maldives",
        "continentName": "Asia",
        "currencycode": "MVR"
    },
    {
        "continent": "AF",
        "capital": "Lilongwe",
        "languages": "ny,yao,tum,swk",
        "geonameId": 927384,
        "south": -17.1295217059999,
        "isoAlpha3": "MWI",
        "north": -9.36722739199996,
        "fipscode": "MI",
        "population": "15447500",
        "east": 35.9185731040001,
        "isoNumeric": "454",
        "areaInSqKm": "118480.0",
        "countrycode": "MW",
        "west": 32.6725205490001,
        "countryName": "Malawi",
        "continentName": "Africa",
        "currencycode": "MWK"
    },
    {
        "continent": "NA",
        "capital": "Mexico City",
        "languages": "es-MX",
        "geonameId": 3996063,
        "south": 14.532866,
        "isoAlpha3": "MEX",
        "north": 32.716759,
        "fipscode": "MX",
        "population": "112468855",
        "east": -86.703392,
        "isoNumeric": "484",
        "areaInSqKm": "1972550.0",
        "countrycode": "MX",
        "west": -118.453949,
        "countryName": "Mexico",
        "continentName": "North America",
        "currencycode": "MXN"
    },
    {
        "continent": "AS",
        "capital": "Kuala Lumpur",
        "languages": "ms-MY,en,zh,ta,te,ml,pa,th",
        "geonameId": 1733045,
        "south": 0.855222,
        "isoAlpha3": "MYS",
        "north": 7.363417,
        "fipscode": "MY",
        "population": "28274729",
        "east": 119.267502,
        "isoNumeric": "458",
        "areaInSqKm": "329750.0",
        "countrycode": "MY",
        "west": 99.643448,
        "countryName": "Malaysia",
        "continentName": "Asia",
        "currencycode": "MYR"
    },
    {
        "continent": "AF",
        "capital": "Maputo",
        "languages": "pt-MZ,vmw",
        "geonameId": 1036973,
        "south": -26.868162,
        "isoAlpha3": "MOZ",
        "north": -10.4731756319999,
        "fipscode": "MZ",
        "population": "22061451",
        "east": 40.838104211,
        "isoNumeric": "508",
        "areaInSqKm": "801590.0",
        "countrycode": "MZ",
        "west": 30.2155500000001,
        "countryName": "Mozambique",
        "continentName": "Africa",
        "currencycode": "MZN"
    },
    {
        "continent": "AF",
        "capital": "Windhoek",
        "languages": "en-NA,af,de,hz,naq",
        "geonameId": 3355338,
        "south": -28.9706389999999,
        "isoAlpha3": "NAM",
        "north": -16.963488173,
        "fipscode": "WA",
        "population": "2128471",
        "east": 25.2617520000001,
        "isoNumeric": "516",
        "areaInSqKm": "825418.0",
        "countrycode": "NA",
        "west": 11.737502061,
        "countryName": "Namibia",
        "continentName": "Africa",
        "currencycode": "NAD"
    },
    {
        "continent": "OC",
        "capital": "Noumea",
        "languages": "fr-NC",
        "geonameId": 2139685,
        "south": -22.698,
        "isoAlpha3": "NCL",
        "north": -19.549778,
        "fipscode": "NC",
        "population": "216494",
        "east": 168.129135,
        "isoNumeric": "540",
        "areaInSqKm": "19060.0",
        "countrycode": "NC",
        "west": 163.564667,
        "countryName": "New Caledonia",
        "continentName": "Oceania",
        "currencycode": "XPF"
    },
    {
        "continent": "AF",
        "capital": "Niamey",
        "languages": "fr-NE,ha,kr,dje",
        "geonameId": 2440476,
        "south": 11.6937560000001,
        "isoAlpha3": "NER",
        "north": 23.5149999920001,
        "fipscode": "NG",
        "population": "15878271",
        "east": 15.9990340000001,
        "isoNumeric": "562",
        "areaInSqKm": "1267000.0",
        "countrycode": "NE",
        "west": 0.162193643000023,
        "countryName": "Niger",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "OC",
        "capital": "Kingston",
        "languages": "en-NF",
        "geonameId": 2155115,
        "south": -29.063076742954735,
        "isoAlpha3": "NFK",
        "north": -28.995170686948427,
        "fipscode": "NF",
        "population": "1828",
        "east": 167.99773740209957,
        "isoNumeric": "574",
        "areaInSqKm": "34.6",
        "countrycode": "NF",
        "west": 167.91543230151365,
        "countryName": "Norfolk Island",
        "continentName": "Oceania",
        "currencycode": "AUD"
    },
    {
        "continent": "AF",
        "capital": "Abuja",
        "languages": "en-NG,ha,yo,ig,ff",
        "geonameId": 2328926,
        "south": 4.277144,
        "isoAlpha3": "NGA",
        "north": 13.892007,
        "fipscode": "NI",
        "population": "154000000",
        "east": 14.680073,
        "isoNumeric": "566",
        "areaInSqKm": "923768.0",
        "countrycode": "NG",
        "west": 2.668432,
        "countryName": "Nigeria",
        "continentName": "Africa",
        "currencycode": "NGN"
    },
    {
        "continent": "NA",
        "capital": "Managua",
        "languages": "es-NI,en",
        "geonameId": 3617476,
        "south": 10.707543,
        "isoAlpha3": "NIC",
        "north": 15.025909,
        "fipscode": "NU",
        "population": "5995928",
        "east": -82.738289,
        "isoNumeric": "558",
        "areaInSqKm": "129494.0",
        "countrycode": "NI",
        "west": -87.690308,
        "countryName": "Nicaragua",
        "continentName": "North America",
        "currencycode": "NIO"
    },
    {
        "continent": "EU",
        "capital": "Amsterdam",
        "languages": "nl-NL,fy-NL",
        "geonameId": 2750405,
        "south": 50.7503674993741,
        "isoAlpha3": "NLD",
        "north": 53.5157125645109,
        "fipscode": "NL",
        "population": "16645000",
        "east": 7.22749859212922,
        "isoNumeric": "528",
        "areaInSqKm": "41526.0",
        "countrycode": "NL",
        "west": 3.35837827202,
        "countryName": "Netherlands",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Oslo",
        "languages": "no,nb,nn,se,fi",
        "geonameId": 3144096,
        "south": 57.97987783489344,
        "isoAlpha3": "NOR",
        "north": 71.1854764998959,
        "fipscode": "NO",
        "population": "5009150",
        "east": 31.063740342248376,
        "isoNumeric": "578",
        "areaInSqKm": "324220.0",
        "countrycode": "NO",
        "west": 4.64182374183584,
        "countryName": "Norway",
        "continentName": "Europe",
        "currencycode": "NOK"
    },
    {
        "continent": "AS",
        "capital": "Kathmandu",
        "languages": "ne,en",
        "geonameId": 1282988,
        "south": 26.3479660710001,
        "isoAlpha3": "NPL",
        "north": 30.447389748,
        "fipscode": "NP",
        "population": "28951852",
        "east": 88.2015257450001,
        "isoNumeric": "524",
        "areaInSqKm": "140800.0",
        "countrycode": "NP",
        "west": 80.058450824,
        "countryName": "Nepal",
        "continentName": "Asia",
        "currencycode": "NPR"
    },
    {
        "continent": "OC",
        "capital": "Yaren",
        "languages": "na,en-NR",
        "geonameId": 2110425,
        "south": -0.552333,
        "isoAlpha3": "NRU",
        "north": -0.504306,
        "fipscode": "NR",
        "population": "10065",
        "east": 166.945282,
        "isoNumeric": "520",
        "areaInSqKm": "21.0",
        "countrycode": "NR",
        "west": 166.899033,
        "countryName": "Nauru",
        "continentName": "Oceania",
        "currencycode": "AUD"
    },
    {
        "continent": "OC",
        "capital": "Alofi",
        "languages": "niu,en-NU",
        "geonameId": 4036232,
        "south": -19.152193,
        "isoAlpha3": "NIU",
        "north": -18.951069,
        "fipscode": "NE",
        "population": "2166",
        "east": -169.775177,
        "isoNumeric": "570",
        "areaInSqKm": "260.0",
        "countrycode": "NU",
        "west": -169.951004,
        "countryName": "Niue",
        "continentName": "Oceania",
        "currencycode": "NZD"
    },
    {
        "continent": "OC",
        "capital": "Wellington",
        "languages": "en-NZ,mi",
        "geonameId": 2186224,
        "south": -47.286026,
        "isoAlpha3": "NZL",
        "north": -34.389668,
        "fipscode": "NZ",
        "population": "4252277",
        "east": -180,
        "isoNumeric": "554",
        "areaInSqKm": "268680.0",
        "countrycode": "NZ",
        "west": 166.7155,
        "countryName": "New Zealand",
        "continentName": "Oceania",
        "currencycode": "NZD"
    },
    {
        "continent": "AS",
        "capital": "Muscat",
        "languages": "ar-OM,en,bal,ur",
        "geonameId": 286963,
        "south": 16.6500835430001,
        "isoAlpha3": "OMN",
        "north": 26.3863334660001,
        "fipscode": "MU",
        "population": "2967717",
        "east": 59.8379173280001,
        "isoNumeric": "512",
        "areaInSqKm": "212460.0",
        "countrycode": "OM",
        "west": 52.0000000000001,
        "countryName": "Oman",
        "continentName": "Asia",
        "currencycode": "OMR"
    },
    {
        "continent": "NA",
        "capital": "Panama City",
        "languages": "es-PA,en",
        "geonameId": 3703430,
        "south": 7.20236920646422,
        "isoAlpha3": "PAN",
        "north": 9.6474132494631,
        "fipscode": "PM",
        "population": "3410676",
        "east": -77.1563637579897,
        "isoNumeric": "591",
        "areaInSqKm": "78200.0",
        "countrycode": "PA",
        "west": -83.0523988577088,
        "countryName": "Panama",
        "continentName": "North America",
        "currencycode": "PAB"
    },
    {
        "continent": "SA",
        "capital": "Lima",
        "languages": "es-PE,qu,ay",
        "geonameId": 3932488,
        "south": -18.3509277356587,
        "isoAlpha3": "PER",
        "north": -0.0386059686681167,
        "fipscode": "PE",
        "population": "29907003",
        "east": -68.6522791042853,
        "isoNumeric": "604",
        "areaInSqKm": "1285220.0",
        "countrycode": "PE",
        "west": -81.3281953622301,
        "countryName": "Peru",
        "continentName": "South America",
        "currencycode": "PEN"
    },
    {
        "continent": "OC",
        "capital": "Papeete",
        "languages": "fr-PF,ty",
        "geonameId": 4030656,
        "south": -27.653572,
        "isoAlpha3": "PYF",
        "north": -7.903573,
        "fipscode": "FP",
        "population": "270485",
        "east": -134.929825,
        "isoNumeric": "258",
        "areaInSqKm": "4167.0",
        "countrycode": "PF",
        "west": -152.877167,
        "countryName": "French Polynesia",
        "continentName": "Oceania",
        "currencycode": "XPF"
    },
    {
        "continent": "OC",
        "capital": "Port Moresby",
        "languages": "en-PG,ho,meu,tpi",
        "geonameId": 2088628,
        "south": -11.657972335,
        "isoAlpha3": "PNG",
        "north": -1.31544446799995,
        "fipscode": "PP",
        "population": "6064515",
        "east": 155.968780519,
        "isoNumeric": "598",
        "areaInSqKm": "462840.0",
        "countrycode": "PG",
        "west": 140.841969,
        "countryName": "Papua New Guinea",
        "continentName": "Oceania",
        "currencycode": "PGK"
    },
    {
        "continent": "AS",
        "capital": "Manila",
        "languages": "tl,en-PH,fil,ceb,tgl,ilo,hil,war,pam,bik,bcl,pag,mrw,tsg,mdh,cbk,krj,sgd,msb,akl,ibg,yka,mta,abx",
        "geonameId": 1694008,
        "south": 4.64209796365014,
        "isoAlpha3": "PHL",
        "north": 21.1218854788318,
        "fipscode": "RP",
        "population": "99900177",
        "east": 126.60497402182328,
        "isoNumeric": "608",
        "areaInSqKm": "300000.0",
        "countrycode": "PH",
        "west": 116.9288644959,
        "countryName": "Philippines",
        "continentName": "Asia",
        "currencycode": "PHP"
    },
    {
        "continent": "AS",
        "capital": "Islamabad",
        "languages": "ur-PK,en-PK,pa,sd,ps,brh",
        "geonameId": 1168579,
        "south": 23.769527435,
        "isoAlpha3": "PAK",
        "north": 37.0841070010001,
        "fipscode": "PK",
        "population": "184404791",
        "east": 77.0132974640001,
        "isoNumeric": "586",
        "areaInSqKm": "803940.0",
        "countrycode": "PK",
        "west": 60.8729720000001,
        "countryName": "Pakistan",
        "continentName": "Asia",
        "currencycode": "PKR"
    },
    {
        "continent": "EU",
        "capital": "Warsaw",
        "languages": "pl",
        "geonameId": 798544,
        "south": 49.0020465193443,
        "isoAlpha3": "POL",
        "north": 54.8357886595169,
        "fipscode": "PL",
        "population": "38500000",
        "east": 24.1457828491313,
        "isoNumeric": "616",
        "areaInSqKm": "312685.0",
        "countrycode": "PL",
        "west": 14.1228850233809,
        "countryName": "Poland",
        "continentName": "Europe",
        "currencycode": "PLN"
    },
    {
        "continent": "NA",
        "capital": "Saint-Pierre",
        "languages": "fr-PM",
        "geonameId": 3424932,
        "south": 46.78264970849848,
        "isoAlpha3": "SPM",
        "north": 47.14376802942701,
        "fipscode": "SB",
        "population": "7012",
        "east": -56.1253298443454,
        "isoNumeric": "666",
        "areaInSqKm": "242.0",
        "countrycode": "PM",
        "west": -56.40709223087083,
        "countryName": "Saint Pierre and Miquelon",
        "continentName": "North America",
        "currencycode": "EUR"
    },
    {
        "continent": "OC",
        "capital": "Adamstown",
        "languages": "en-PN",
        "geonameId": 4030699,
        "south": -24.672565,
        "isoAlpha3": "PCN",
        "north": -24.3299386198549,
        "fipscode": "PC",
        "population": "46",
        "east": -124.77285,
        "isoNumeric": "612",
        "areaInSqKm": "47.0",
        "countrycode": "PN",
        "west": -128.35699011119425,
        "countryName": "Pitcairn Islands",
        "continentName": "Oceania",
        "currencycode": "NZD"
    },
    {
        "continent": "NA",
        "capital": "San Juan",
        "languages": "en-PR,es-PR",
        "geonameId": 4566966,
        "south": 17.926405,
        "isoAlpha3": "PRI",
        "north": 18.520166,
        "fipscode": "RQ",
        "population": "3916632",
        "east": -65.2430816766763,
        "isoNumeric": "630",
        "areaInSqKm": "9104.0",
        "countrycode": "PR",
        "west": -67.942726,
        "countryName": "Puerto Rico",
        "continentName": "North America",
        "currencycode": "USD"
    },
    {
        "continent": "AS",
        "capital": "",
        "languages": "ar-PS",
        "geonameId": 6254930,
        "south": 31.2200520000001,
        "isoAlpha3": "PSE",
        "north": 32.5520881030001,
        "fipscode": "WE",
        "population": "3800000",
        "east": 35.5740520000001,
        "isoNumeric": "275",
        "areaInSqKm": "5970.0",
        "countrycode": "PS",
        "west": 34.2186994300001,
        "countryName": "Palestine",
        "continentName": "Asia",
        "currencycode": "ILS"
    },
    {
        "continent": "EU",
        "capital": "Lisbon",
        "languages": "pt-PT,mwl",
        "geonameId": 2264397,
        "south": 36.96125,
        "isoAlpha3": "PRT",
        "north": 42.154311127408,
        "fipscode": "PO",
        "population": "10676000",
        "east": -6.18915930748288,
        "isoNumeric": "620",
        "areaInSqKm": "92391.0",
        "countrycode": "PT",
        "west": -9.50052660716588,
        "countryName": "Portugal",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "OC",
        "capital": "Melekeok",
        "languages": "pau,sov,en-PW,tox,ja,fil,zh",
        "geonameId": 1559582,
        "south": 2.8036,
        "isoAlpha3": "PLW",
        "north": 8.46966,
        "fipscode": "PS",
        "population": "19907",
        "east": 134.72307,
        "isoNumeric": "585",
        "areaInSqKm": "458.0",
        "countrycode": "PW",
        "west": 131.11788,
        "countryName": "Palau",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "SA",
        "capital": "Asunción",
        "languages": "es-PY,gn",
        "geonameId": 3437598,
        "south": -27.5918335646318,
        "isoAlpha3": "PRY",
        "north": -19.2896000004762,
        "fipscode": "PA",
        "population": "6375830",
        "east": -54.2589239104835,
        "isoNumeric": "600",
        "areaInSqKm": "406750.0",
        "countrycode": "PY",
        "west": -62.6446174378624,
        "countryName": "Paraguay",
        "continentName": "South America",
        "currencycode": "PYG"
    },
    {
        "continent": "AS",
        "capital": "Doha",
        "languages": "ar-QA,es",
        "geonameId": 289688,
        "south": 24.4711111230001,
        "isoAlpha3": "QAT",
        "north": 26.1578818880001,
        "fipscode": "QA",
        "population": "840926",
        "east": 51.6315537500001,
        "isoNumeric": "634",
        "areaInSqKm": "11437.0",
        "countrycode": "QA",
        "west": 50.750030995,
        "countryName": "Qatar",
        "continentName": "Asia",
        "currencycode": "QAR"
    },
    {
        "continent": "AF",
        "capital": "Saint-Denis",
        "languages": "fr-RE",
        "geonameId": 935317,
        "south": -21.389228821,
        "isoAlpha3": "REU",
        "north": -20.8717861179999,
        "fipscode": "RE",
        "population": "776948",
        "east": 55.836700439,
        "isoNumeric": "638",
        "areaInSqKm": "2517.0",
        "countrycode": "RE",
        "west": 55.21648407,
        "countryName": "Réunion",
        "continentName": "Africa",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Bucharest",
        "languages": "ro,hu,rom",
        "geonameId": 798549,
        "south": 43.6190166499833,
        "isoAlpha3": "ROU",
        "north": 48.2653912058468,
        "fipscode": "RO",
        "population": "21959278",
        "east": 29.7152986907701,
        "isoNumeric": "642",
        "areaInSqKm": "237500.0",
        "countrycode": "RO",
        "west": 20.2619949052262,
        "countryName": "Romania",
        "continentName": "Europe",
        "currencycode": "RON"
    },
    {
        "continent": "EU",
        "capital": "Belgrade",
        "languages": "sr,hu,bs,rom",
        "geonameId": 6290252,
        "south": 42.2315030010001,
        "isoAlpha3": "SRB",
        "north": 46.189446,
        "fipscode": "RI",
        "population": "7344847",
        "east": 23.0063870060001,
        "isoNumeric": "688",
        "areaInSqKm": "88361.0",
        "countrycode": "RS",
        "west": 18.838044043,
        "countryName": "Serbia",
        "continentName": "Europe",
        "currencycode": "RSD"
    },
    {
        "continent": "EU",
        "capital": "Moscow",
        "languages": "ru,tt,xal,cau,ady,kv,ce,tyv,cv,udm,tut,mns,bua,myv,mdf,chm,ba,inh,tut,kbd,krc,av,sah,nog",
        "geonameId": 2017370,
        "south": 41.1853530000001,
        "isoAlpha3": "RUS",
        "north": 81.8616409300001,
        "fipscode": "RS",
        "population": "140702000",
        "east": -169.05,
        "isoNumeric": "643",
        "areaInSqKm": "1.71E7",
        "countrycode": "RU",
        "west": 19.25,
        "countryName": "Russia",
        "continentName": "Europe",
        "currencycode": "RUB"
    },
    {
        "continent": "AF",
        "capital": "Kigali",
        "languages": "rw,en-RW,fr-RW,sw",
        "geonameId": 49518,
        "south": -2.84023010213747,
        "isoAlpha3": "RWA",
        "north": -1.04716670707785,
        "fipscode": "RW",
        "population": "11055976",
        "east": 30.8997466415943,
        "isoNumeric": "646",
        "areaInSqKm": "26338.0",
        "countrycode": "RW",
        "west": 28.8617308206209,
        "countryName": "Rwanda",
        "continentName": "Africa",
        "currencycode": "RWF"
    },
    {
        "continent": "AS",
        "capital": "Riyadh",
        "languages": "ar-SA",
        "geonameId": 102358,
        "south": 16.379528001,
        "isoAlpha3": "SAU",
        "north": 32.1542840000001,
        "fipscode": "SA",
        "population": "25731776",
        "east": 55.6667,
        "isoNumeric": "682",
        "areaInSqKm": "1960582.0",
        "countrycode": "SA",
        "west": 34.495693,
        "countryName": "Saudi Arabia",
        "continentName": "Asia",
        "currencycode": "SAR"
    },
    {
        "continent": "OC",
        "capital": "Honiara",
        "languages": "en-SB,tpi",
        "geonameId": 2103350,
        "south": -11.850555,
        "isoAlpha3": "SLB",
        "north": -6.589611,
        "fipscode": "BP",
        "population": "559198",
        "east": 166.980865,
        "isoNumeric": "090",
        "areaInSqKm": "28450.0",
        "countrycode": "SB",
        "west": 155.508606,
        "countryName": "Solomon Islands",
        "continentName": "Oceania",
        "currencycode": "SBD"
    },
    {
        "continent": "AF",
        "capital": "Victoria",
        "languages": "en-SC,fr-SC",
        "geonameId": 241170,
        "south": -9.753867,
        "isoAlpha3": "SYC",
        "north": -4.283717,
        "fipscode": "SE",
        "population": "88340",
        "east": 56.29770287937299,
        "isoNumeric": "690",
        "areaInSqKm": "455.0",
        "countrycode": "SC",
        "west": 46.204769,
        "countryName": "Seychelles",
        "continentName": "Africa",
        "currencycode": "SCR"
    },
    {
        "continent": "AF",
        "capital": "Khartoum",
        "languages": "ar-SD,en,fia",
        "geonameId": 366755,
        "south": 9.48888700000003,
        "isoAlpha3": "SDN",
        "north": 23.1464092140001,
        "fipscode": "SU",
        "population": "35000000",
        "east": 38.5822502880001,
        "isoNumeric": "729",
        "areaInSqKm": "1861484.0",
        "countrycode": "SD",
        "west": 21.8146345210001,
        "countryName": "Sudan",
        "continentName": "Africa",
        "currencycode": "SDG"
    },
    {
        "continent": "EU",
        "capital": "Stockholm",
        "languages": "sv-SE,se,sma,fi-SE",
        "geonameId": 2661886,
        "south": 55.3374438220002,
        "isoAlpha3": "SWE",
        "north": 69.0599672666879,
        "fipscode": "SW",
        "population": "9828655",
        "east": 24.155245238099,
        "isoNumeric": "752",
        "areaInSqKm": "449964.0",
        "countrycode": "SE",
        "west": 11.109499387126,
        "countryName": "Sweden",
        "continentName": "Europe",
        "currencycode": "SEK"
    },
    {
        "continent": "AS",
        "capital": "Singapore",
        "languages": "cmn,en-SG,ms-SG,ta-SG,zh-SG",
        "geonameId": 1880251,
        "south": 1.21065456224784,
        "isoAlpha3": "SGP",
        "north": 1.47077483208476,
        "fipscode": "SN",
        "population": "4701069",
        "east": 104.043617447514,
        "isoNumeric": "702",
        "areaInSqKm": "692.7",
        "countrycode": "SG",
        "west": 103.605700705134,
        "countryName": "Singapore",
        "continentName": "Asia",
        "currencycode": "SGD"
    },
    {
        "continent": "AF",
        "capital": "Jamestown",
        "languages": "en-SH",
        "geonameId": 3370751,
        "south": -16.019543,
        "isoAlpha3": "SHN",
        "north": -7.887815,
        "fipscode": "SH",
        "population": "7460",
        "east": -5.638753,
        "isoNumeric": "654",
        "areaInSqKm": "410.0",
        "countrycode": "SH",
        "west": -14.42123,
        "countryName": "Saint Helena",
        "continentName": "Africa",
        "currencycode": "SHP"
    },
    {
        "continent": "EU",
        "capital": "Ljubljana",
        "languages": "sl,sh",
        "geonameId": 3190538,
        "south": 45.421812998164,
        "isoAlpha3": "SVN",
        "north": 46.8766275518195,
        "fipscode": "SI",
        "population": "2007000",
        "east": 16.6106311807,
        "isoNumeric": "705",
        "areaInSqKm": "20273.0",
        "countrycode": "SI",
        "west": 13.3753342064709,
        "countryName": "Slovenia",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "EU",
        "capital": "Longyearbyen",
        "languages": "no,ru",
        "geonameId": 607072,
        "south": 79.220306,
        "isoAlpha3": "SJM",
        "north": 80.762085,
        "fipscode": "SV",
        "population": "2550",
        "east": 33.287334,
        "isoNumeric": "744",
        "areaInSqKm": "62049.0",
        "countrycode": "SJ",
        "west": 17.699389,
        "countryName": "Svalbard and Jan Mayen",
        "continentName": "Europe",
        "currencycode": "NOK"
    },
    {
        "continent": "EU",
        "capital": "Bratislava",
        "languages": "sk,hu",
        "geonameId": 3057568,
        "south": 47.7313590000001,
        "isoAlpha3": "SVK",
        "north": 49.6137360000001,
        "fipscode": "LO",
        "population": "5455000",
        "east": 22.5657383340001,
        "isoNumeric": "703",
        "areaInSqKm": "48845.0",
        "countrycode": "SK",
        "west": 16.8334234020001,
        "countryName": "Slovakia",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Freetown",
        "languages": "en-SL,men,tem",
        "geonameId": 2403846,
        "south": 6.92343700100002,
        "isoAlpha3": "SLE",
        "north": 9.99997300000007,
        "fipscode": "SL",
        "population": "5245695",
        "east": -10.2716829999999,
        "isoNumeric": "694",
        "areaInSqKm": "71740.0",
        "countrycode": "SL",
        "west": -13.302128077,
        "countryName": "Sierra Leone",
        "continentName": "Africa",
        "currencycode": "SLL"
    },
    {
        "continent": "EU",
        "capital": "San Marino",
        "languages": "it-SM",
        "geonameId": 3168068,
        "south": 43.8937002210188,
        "isoAlpha3": "SMR",
        "north": 43.9920929668161,
        "fipscode": "SM",
        "population": "31477",
        "east": 12.51584904544211,
        "isoNumeric": "674",
        "areaInSqKm": "61.2",
        "countrycode": "SM",
        "west": 12.403605260165023,
        "countryName": "San Marino",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Dakar",
        "languages": "fr-SN,wo,fuc,mnk",
        "geonameId": 2245662,
        "south": 12.307289079,
        "isoAlpha3": "SEN",
        "north": 16.6929572170001,
        "fipscode": "SG",
        "population": "12323252",
        "east": -11.345768371,
        "isoNumeric": "686",
        "areaInSqKm": "196190.0",
        "countrycode": "SN",
        "west": -17.529520035,
        "countryName": "Senegal",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "AF",
        "capital": "Mogadishu",
        "languages": "so-SO,ar-SO,it,en-SO",
        "geonameId": 51537,
        "south": -1.66203236399997,
        "isoAlpha3": "SOM",
        "north": 11.9887353730001,
        "fipscode": "SO",
        "population": "10112453",
        "east": 51.4150313960001,
        "isoNumeric": "706",
        "areaInSqKm": "637657.0",
        "countrycode": "SO",
        "west": 40.9943730000001,
        "countryName": "Somalia",
        "continentName": "Africa",
        "currencycode": "SOS"
    },
    {
        "continent": "SA",
        "capital": "Paramaribo",
        "languages": "nl-SR,en,srn,hns,jv",
        "geonameId": 3382998,
        "south": 1.83730600000007,
        "isoAlpha3": "SUR",
        "north": 6.01550458300005,
        "fipscode": "NS",
        "population": "492829",
        "east": -53.978763,
        "isoNumeric": "740",
        "areaInSqKm": "163270.0",
        "countrycode": "SR",
        "west": -58.070505999,
        "countryName": "Suriname",
        "continentName": "South America",
        "currencycode": "SRD"
    },
    {
        "continent": "AF",
        "capital": "Juba",
        "languages": "en",
        "geonameId": 7909807,
        "south": 3.48898000000003,
        "isoAlpha3": "SSD",
        "north": 12.236389,
        "fipscode": "OD",
        "population": "8260490",
        "east": 35.9489970000001,
        "isoNumeric": "728",
        "areaInSqKm": "644329.0",
        "countrycode": "SS",
        "west": 23.4408490000001,
        "countryName": "South Sudan",
        "continentName": "Africa",
        "currencycode": "SSP"
    },
    {
        "continent": "AF",
        "capital": "São Tomé",
        "languages": "pt-ST",
        "geonameId": 2410758,
        "south": 0.024766,
        "isoAlpha3": "STP",
        "north": 1.701323,
        "fipscode": "TP",
        "population": "197700",
        "east": 7.466374,
        "isoNumeric": "678",
        "areaInSqKm": "1001.0",
        "countrycode": "ST",
        "west": 6.47017,
        "countryName": "São Tomé and Príncipe",
        "continentName": "Africa",
        "currencycode": "STD"
    },
    {
        "continent": "NA",
        "capital": "San Salvador",
        "languages": "es-SV",
        "geonameId": 3585968,
        "south": 13.153004391,
        "isoAlpha3": "SLV",
        "north": 14.450557001,
        "fipscode": "ES",
        "population": "6052064",
        "east": -87.692162,
        "isoNumeric": "222",
        "areaInSqKm": "21040.0",
        "countrycode": "SV",
        "west": -90.134654476,
        "countryName": "El Salvador",
        "continentName": "North America",
        "currencycode": "USD"
    },
    {
        "continent": "NA",
        "capital": "Philipsburg",
        "languages": "nl,en",
        "geonameId": 7609695,
        "south": 18.00509989712575,
        "isoAlpha3": "SXM",
        "north": 18.0641148010001,
        "fipscode": "NN",
        "population": "37429",
        "east": -63.01365933767215,
        "isoNumeric": "534",
        "areaInSqKm": "21.0",
        "countrycode": "SX",
        "west": -63.13916381600001,
        "countryName": "Sint Maarten",
        "continentName": "North America",
        "currencycode": "ANG"
    },
    {
        "continent": "AS",
        "capital": "Damascus",
        "languages": "ar-SY,ku,hy,arc,fr,en",
        "geonameId": 163843,
        "south": 32.311136,
        "isoAlpha3": "SYR",
        "north": 37.3205689060001,
        "fipscode": "SY",
        "population": "22198110",
        "east": 42.376309,
        "isoNumeric": "760",
        "areaInSqKm": "185180.0",
        "countrycode": "SY",
        "west": 35.587211,
        "countryName": "Syria",
        "continentName": "Asia",
        "currencycode": "SYP"
    },
    {
        "continent": "AF",
        "capital": "Mbabane",
        "languages": "en-SZ,ss-SZ",
        "geonameId": 934841,
        "south": -27.317402,
        "isoAlpha3": "SWZ",
        "north": -25.7179199999999,
        "fipscode": "WZ",
        "population": "1354051",
        "east": 32.1349066610001,
        "isoNumeric": "748",
        "areaInSqKm": "17363.0",
        "countrycode": "SZ",
        "west": 30.7906400000001,
        "countryName": "Swaziland",
        "continentName": "Africa",
        "currencycode": "SZL"
    },
    {
        "continent": "NA",
        "capital": "Cockburn Town",
        "languages": "en-TC",
        "geonameId": 3576916,
        "south": 21.422626,
        "isoAlpha3": "TCA",
        "north": 21.961878,
        "fipscode": "TK",
        "population": "20556",
        "east": -71.123642,
        "isoNumeric": "796",
        "areaInSqKm": "430.0",
        "countrycode": "TC",
        "west": -72.483871,
        "countryName": "Turks and Caicos Islands",
        "continentName": "North America",
        "currencycode": "USD"
    },
    {
        "continent": "AF",
        "capital": "N'Djamena",
        "languages": "fr-TD,ar-TD,sre",
        "geonameId": 2434508,
        "south": 7.44297500000005,
        "isoAlpha3": "TCD",
        "north": 23.4523611160001,
        "fipscode": "CD",
        "population": "10543464",
        "east": 24.0000000000001,
        "isoNumeric": "148",
        "areaInSqKm": "1284000.0",
        "countrycode": "TD",
        "west": 13.47,
        "countryName": "Chad",
        "continentName": "Africa",
        "currencycode": "XAF"
    },
    {
        "continent": "AN",
        "capital": "Port-aux-Français",
        "languages": "fr",
        "geonameId": 1546748,
        "south": -49.735184,
        "isoAlpha3": "ATF",
        "north": -37.790722,
        "fipscode": "FS",
        "population": "140",
        "east": 77.598808,
        "isoNumeric": "260",
        "areaInSqKm": "7829.0",
        "countrycode": "TF",
        "west": 50.170258,
        "countryName": "French Southern Territories",
        "continentName": "Antarctica",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Lomé",
        "languages": "fr-TG,ee,hna,kbp,dag,ha",
        "geonameId": 2363686,
        "south": 6.11225958700004,
        "isoAlpha3": "TGO",
        "north": 11.1394984250001,
        "fipscode": "TO",
        "population": "6587239",
        "east": 1.80890722900006,
        "isoNumeric": "768",
        "areaInSqKm": "56785.0",
        "countrycode": "TG",
        "west": -0.144041999999956,
        "countryName": "Togo",
        "continentName": "Africa",
        "currencycode": "XOF"
    },
    {
        "continent": "AS",
        "capital": "Bangkok",
        "languages": "th,en",
        "geonameId": 1605651,
        "south": 5.61,
        "isoAlpha3": "THA",
        "north": 20.463194,
        "fipscode": "TH",
        "population": "67089500",
        "east": 105.639389,
        "isoNumeric": "764",
        "areaInSqKm": "514000.0",
        "countrycode": "TH",
        "west": 97.345642,
        "countryName": "Thailand",
        "continentName": "Asia",
        "currencycode": "THB"
    },
    {
        "continent": "AS",
        "capital": "Dushanbe",
        "languages": "tg,ru",
        "geonameId": 1220409,
        "south": 36.672037001,
        "isoAlpha3": "TJK",
        "north": 41.0443670000001,
        "fipscode": "TI",
        "population": "7487489",
        "east": 75.1539560000001,
        "isoNumeric": "762",
        "areaInSqKm": "143100.0",
        "countrycode": "TJ",
        "west": 67.3420120000001,
        "countryName": "Tajikistan",
        "continentName": "Asia",
        "currencycode": "TJS"
    },
    {
        "continent": "OC",
        "capital": "",
        "languages": "tkl,en-TK",
        "geonameId": 4031074,
        "south": -9.381111145019531,
        "isoAlpha3": "TKL",
        "north": -8.553613662719727,
        "fipscode": "TL",
        "population": "1466",
        "east": -171.21142578125,
        "isoNumeric": "772",
        "areaInSqKm": "10.0",
        "countrycode": "TK",
        "west": -172.50033569335938,
        "countryName": "Tokelau",
        "continentName": "Oceania",
        "currencycode": "NZD"
    },
    {
        "continent": "OC",
        "capital": "Dili",
        "languages": "tet,pt-TL,id,en",
        "geonameId": 1966436,
        "south": -9.504650115966797,
        "isoAlpha3": "TLS",
        "north": -8.12687015533447,
        "fipscode": "TT",
        "population": "1154625",
        "east": 127.34211730957031,
        "isoNumeric": "626",
        "areaInSqKm": "15007.0",
        "countrycode": "TL",
        "west": 124.04464721679688,
        "countryName": "East Timor",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "AS",
        "capital": "Ashgabat",
        "languages": "tk,ru,uz",
        "geonameId": 1218197,
        "south": 35.1290930000001,
        "isoAlpha3": "TKM",
        "north": 42.7982617260001,
        "fipscode": "TX",
        "population": "4940916",
        "east": 66.7073530000001,
        "isoNumeric": "795",
        "areaInSqKm": "488100.0",
        "countrycode": "TM",
        "west": 52.4455780650001,
        "countryName": "Turkmenistan",
        "continentName": "Asia",
        "currencycode": "TMT"
    },
    {
        "continent": "AF",
        "capital": "Tunis",
        "languages": "ar-TN,fr",
        "geonameId": 2464461,
        "south": 30.2415834110001,
        "isoAlpha3": "TUN",
        "north": 37.5419886350001,
        "fipscode": "TS",
        "population": "10589025",
        "east": 11.608143339,
        "isoNumeric": "788",
        "areaInSqKm": "163610.0",
        "countrycode": "TN",
        "west": 7.52252789300007,
        "countryName": "Tunisia",
        "continentName": "Africa",
        "currencycode": "TND"
    },
    {
        "continent": "OC",
        "capital": "Nuku'alofa",
        "languages": "to,en-TO",
        "geonameId": 4032283,
        "south": -21.455057,
        "isoAlpha3": "TON",
        "north": -15.562988,
        "fipscode": "TN",
        "population": "122580",
        "east": -173.907578,
        "isoNumeric": "776",
        "areaInSqKm": "748.0",
        "countrycode": "TO",
        "west": -175.682266,
        "countryName": "Tonga",
        "continentName": "Oceania",
        "currencycode": "TOP"
    },
    {
        "continent": "AS",
        "capital": "Ankara",
        "languages": "tr-TR,ku,diq,az,av",
        "geonameId": 298795,
        "south": 35.815418,
        "isoAlpha3": "TUR",
        "north": 42.107613,
        "fipscode": "TU",
        "population": "77804122",
        "east": 44.834999,
        "isoNumeric": "792",
        "areaInSqKm": "780580.0",
        "countrycode": "TR",
        "west": 25.668501,
        "countryName": "Turkey",
        "continentName": "Asia",
        "currencycode": "TRY"
    },
    {
        "continent": "NA",
        "capital": "Port of Spain",
        "languages": "en-TT,hns,fr,es,zh",
        "geonameId": 3573591,
        "south": 10.0411386500001,
        "isoAlpha3": "TTO",
        "north": 11.348472596,
        "fipscode": "TD",
        "population": "1328019",
        "east": -60.519332886,
        "isoNumeric": "780",
        "areaInSqKm": "5128.0",
        "countrycode": "TT",
        "west": -61.933723449,
        "countryName": "Trinidad and Tobago",
        "continentName": "North America",
        "currencycode": "TTD"
    },
    {
        "continent": "OC",
        "capital": "Funafuti",
        "languages": "tvl,en,sm,gil",
        "geonameId": 2110297,
        "south": -10.801169,
        "isoAlpha3": "TUV",
        "north": -5.641972,
        "fipscode": "TV",
        "population": "10472",
        "east": 179.863281,
        "isoNumeric": "798",
        "areaInSqKm": "26.0",
        "countrycode": "TV",
        "west": 176.064865,
        "countryName": "Tuvalu",
        "continentName": "Oceania",
        "currencycode": "AUD"
    },
    {
        "continent": "AS",
        "capital": "Taipei",
        "languages": "zh-TW,zh,nan,hak",
        "geonameId": 1668284,
        "south": 21.896606934717,
        "isoAlpha3": "TWN",
        "north": 25.3002899036181,
        "fipscode": "TW",
        "population": "22894384",
        "east": 122.006739823315,
        "isoNumeric": "158",
        "areaInSqKm": "35980.0",
        "countrycode": "TW",
        "west": 119.534691,
        "countryName": "Taiwan",
        "continentName": "Asia",
        "currencycode": "TWD"
    },
    {
        "continent": "AF",
        "capital": "Dodoma",
        "languages": "sw-TZ,en,ar",
        "geonameId": 149590,
        "south": -11.761254,
        "isoAlpha3": "TZA",
        "north": -0.984396999999944,
        "fipscode": "TZ",
        "population": "41892895",
        "east": 40.4448279960001,
        "isoNumeric": "834",
        "areaInSqKm": "945087.0",
        "countrycode": "TZ",
        "west": 29.34,
        "countryName": "Tanzania",
        "continentName": "Africa",
        "currencycode": "TZS"
    },
    {
        "continent": "EU",
        "capital": "Kiev",
        "languages": "uk,ru-UA,rom,pl,hu",
        "geonameId": 690791,
        "south": 44.3820571900001,
        "isoAlpha3": "UKR",
        "north": 52.3793713250001,
        "fipscode": "UP",
        "population": "45415596",
        "east": 40.22048033,
        "isoNumeric": "804",
        "areaInSqKm": "603700.0",
        "countrycode": "UA",
        "west": 22.137078,
        "countryName": "Ukraine",
        "continentName": "Europe",
        "currencycode": "UAH"
    },
    {
        "continent": "AF",
        "capital": "Kampala",
        "languages": "en-UG,lg,sw,ar",
        "geonameId": 226074,
        "south": -1.48153052848838,
        "isoAlpha3": "UGA",
        "north": 4.23136926690327,
        "fipscode": "UG",
        "population": "33398682",
        "east": 35.0010535324228,
        "isoNumeric": "800",
        "areaInSqKm": "236040.0",
        "countrycode": "UG",
        "west": 29.573465338129,
        "countryName": "Uganda",
        "continentName": "Africa",
        "currencycode": "UGX"
    },
    {
        "continent": "OC",
        "capital": "",
        "languages": "en-UM",
        "geonameId": 5854968,
        "south": -0.389006,
        "isoAlpha3": "UMI",
        "north": 28.219814,
        "fipscode": "",
        "population": "0",
        "east": 166.654526,
        "isoNumeric": "581",
        "areaInSqKm": "0.0",
        "countrycode": "UM",
        "west": -177.392029,
        "countryName": "U.S. Minor Outlying Islands",
        "continentName": "Oceania",
        "currencycode": "USD"
    },
    {
        "continent": "NA",
        "capital": "Washington",
        "languages": "en-US,es-US,haw,fr",
        "geonameId": 6252001,
        "south": 24.544093,
        "isoAlpha3": "USA",
        "north": 49.384358,
        "fipscode": "US",
        "population": "310232863",
        "east": -66.949607,
        "isoNumeric": "840",
        "areaInSqKm": "9629091.0",
        "countrycode": "US",
        "west": -124.733692,
        "countryName": "United States",
        "continentName": "North America",
        "currencycode": "USD"
    },
    {
        "continent": "SA",
        "capital": "Montevideo",
        "languages": "es-UY",
        "geonameId": 3439705,
        "south": -34.9740543027064,
        "isoAlpha3": "URY",
        "north": -30.0855024328825,
        "fipscode": "UY",
        "population": "3477000",
        "east": -53.1810509360802,
        "isoNumeric": "858",
        "areaInSqKm": "176220.0",
        "countrycode": "UY",
        "west": -58.4393489790361,
        "countryName": "Uruguay",
        "continentName": "South America",
        "currencycode": "UYU"
    },
    {
        "continent": "AS",
        "capital": "Tashkent",
        "languages": "uz,ru,tg",
        "geonameId": 1512440,
        "south": 37.172269828,
        "isoAlpha3": "UZB",
        "north": 45.5900750010001,
        "fipscode": "UZ",
        "population": "27865738",
        "east": 73.1489460000001,
        "isoNumeric": "860",
        "areaInSqKm": "447400.0",
        "countrycode": "UZ",
        "west": 55.9982180000001,
        "countryName": "Uzbekistan",
        "continentName": "Asia",
        "currencycode": "UZS"
    },
    {
        "continent": "EU",
        "capital": "Vatican City",
        "languages": "la,it,fr",
        "geonameId": 3164670,
        "south": 41.90027960306854,
        "isoAlpha3": "VAT",
        "north": 41.90743830885576,
        "fipscode": "VT",
        "population": "921",
        "east": 12.45837546629481,
        "isoNumeric": "336",
        "areaInSqKm": "0.44",
        "countrycode": "VA",
        "west": 12.44570678169205,
        "countryName": "Vatican City",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "NA",
        "capital": "Kingstown",
        "languages": "en-VC,fr",
        "geonameId": 3577815,
        "south": 12.5839734740001,
        "isoAlpha3": "VCT",
        "north": 13.382421799995889,
        "fipscode": "VC",
        "population": "104217",
        "east": -61.11340272108896,
        "isoNumeric": "670",
        "areaInSqKm": "389.0",
        "countrycode": "VC",
        "west": -61.4608524069999,
        "countryName": "Saint Vincent and the Grenadines",
        "continentName": "North America",
        "currencycode": "XCD"
    },
    {
        "continent": "SA",
        "capital": "Caracas",
        "languages": "es-VE",
        "geonameId": 3625428,
        "south": 0.626311,
        "isoAlpha3": "VEN",
        "north": 12.201903,
        "fipscode": "VE",
        "population": "27223228",
        "east": -59.80378,
        "isoNumeric": "862",
        "areaInSqKm": "912050.0",
        "countrycode": "VE",
        "west": -73.354073,
        "countryName": "Venezuela",
        "continentName": "South America",
        "currencycode": "VES"
    },
    {
        "continent": "NA",
        "capital": "Road Town",
        "languages": "en-VG",
        "geonameId": 3577718,
        "south": 18.383710898211305,
        "isoAlpha3": "VGB",
        "north": 18.757221,
        "fipscode": "VI",
        "population": "21730",
        "east": -64.268768,
        "isoNumeric": "092",
        "areaInSqKm": "153.0",
        "countrycode": "VG",
        "west": -64.71312752730364,
        "countryName": "British Virgin Islands",
        "continentName": "North America",
        "currencycode": "USD"
    },
    {
        "continent": "NA",
        "capital": "Charlotte Amalie",
        "languages": "en-VI",
        "geonameId": 4796775,
        "south": 17.673931,
        "isoAlpha3": "VIR",
        "north": 18.415382,
        "fipscode": "VQ",
        "population": "108708",
        "east": -64.565193,
        "isoNumeric": "850",
        "areaInSqKm": "352.0",
        "countrycode": "VI",
        "west": -65.101333,
        "countryName": "U.S. Virgin Islands",
        "continentName": "North America",
        "currencycode": "USD"
    },
    {
        "continent": "AS",
        "capital": "Hanoi",
        "languages": "vi,en,fr,zh,km",
        "geonameId": 1562822,
        "south": 8.559611,
        "isoAlpha3": "VNM",
        "north": 23.388834,
        "fipscode": "VM",
        "population": "89571130",
        "east": 109.464638,
        "isoNumeric": "704",
        "areaInSqKm": "329560.0",
        "countrycode": "VN",
        "west": 102.148224,
        "countryName": "Vietnam",
        "continentName": "Asia",
        "currencycode": "VND"
    },
    {
        "continent": "OC",
        "capital": "Port Vila",
        "languages": "bi,en-VU,fr-VU",
        "geonameId": 2134431,
        "south": -20.248945,
        "isoAlpha3": "VUT",
        "north": -13.073444,
        "fipscode": "NH",
        "population": "221552",
        "east": 169.904785,
        "isoNumeric": "548",
        "areaInSqKm": "12200.0",
        "countrycode": "VU",
        "west": 166.524979,
        "countryName": "Vanuatu",
        "continentName": "Oceania",
        "currencycode": "VUV"
    },
    {
        "continent": "OC",
        "capital": "Mata-Utu",
        "languages": "wls,fud,fr-WF",
        "geonameId": 4034749,
        "south": -14.314559989820843,
        "isoAlpha3": "WLF",
        "north": -13.216758181061444,
        "fipscode": "WF",
        "population": "16025",
        "east": -176.16174317718253,
        "isoNumeric": "876",
        "areaInSqKm": "274.0",
        "countrycode": "WF",
        "west": -178.1848112896414,
        "countryName": "Wallis and Futuna",
        "continentName": "Oceania",
        "currencycode": "XPF"
    },
    {
        "continent": "OC",
        "capital": "Apia",
        "languages": "sm,en-WS",
        "geonameId": 4034894,
        "south": -14.049015687969286,
        "isoAlpha3": "WSM",
        "north": -13.440157771394277,
        "fipscode": "WS",
        "population": "192001",
        "east": -171.42329410058596,
        "isoNumeric": "882",
        "areaInSqKm": "2944.0",
        "countrycode": "WS",
        "west": -172.8035771799316,
        "countryName": "Samoa",
        "continentName": "Oceania",
        "currencycode": "WST"
    },
    {
        "continent": "EU",
        "capital": "Pristina",
        "languages": "sq,sr",
        "geonameId": 831053,
        "south": 41.857641001,
        "isoAlpha3": "XKX",
        "north": 43.2676851730001,
        "fipscode": "KV",
        "population": "1800000",
        "east": 21.7898670000001,
        "isoNumeric": "0",
        "areaInSqKm": "10908.0",
        "countrycode": "XK",
        "west": 20.014284,
        "countryName": "Kosovo",
        "continentName": "Europe",
        "currencycode": "EUR"
    },
    {
        "continent": "AS",
        "capital": "Sanaa",
        "languages": "ar-YE",
        "geonameId": 69543,
        "south": 12.1110910264462,
        "isoAlpha3": "YEM",
        "north": 18.9999989031009,
        "fipscode": "YM",
        "population": "23495361",
        "east": 54.5305388163283,
        "isoNumeric": "887",
        "areaInSqKm": "527970.0",
        "countrycode": "YE",
        "west": 42.5325394314234,
        "countryName": "Yemen",
        "continentName": "Asia",
        "currencycode": "YER"
    },
    {
        "continent": "AF",
        "capital": "Mamoudzou",
        "languages": "fr-YT",
        "geonameId": 1024031,
        "south": -13.000132,
        "isoAlpha3": "MYT",
        "north": -12.648891,
        "fipscode": "MF",
        "population": "159042",
        "east": 45.29295,
        "isoNumeric": "175",
        "areaInSqKm": "374.0",
        "countrycode": "YT",
        "west": 45.03796,
        "countryName": "Mayotte",
        "continentName": "Africa",
        "currencycode": "EUR"
    },
    {
        "continent": "AF",
        "capital": "Pretoria",
        "languages": "zu,xh,af,nso,en-ZA,tn,st,ts,ss,ve,nr",
        "geonameId": 953987,
        "south": -34.8341700029999,
        "isoAlpha3": "ZAF",
        "north": -22.1250300579999,
        "fipscode": "SF",
        "population": "49000000",
        "east": 32.944984945,
        "isoNumeric": "710",
        "areaInSqKm": "1219912.0",
        "countrycode": "ZA",
        "west": 16.45189,
        "countryName": "South Africa",
        "continentName": "Africa",
        "currencycode": "ZAR"
    },
    {
        "continent": "AF",
        "capital": "Lusaka",
        "languages": "en-ZM,bem,loz,lun,lue,ny,toi",
        "geonameId": 895949,
        "south": -18.077418,
        "isoAlpha3": "ZMB",
        "north": -8.20328399999994,
        "fipscode": "ZA",
        "population": "13460305",
        "east": 33.7090304810001,
        "isoNumeric": "894",
        "areaInSqKm": "752614.0",
        "countrycode": "ZM",
        "west": 21.999350925,
        "countryName": "Zambia",
        "continentName": "Africa",
        "currencycode": "ZMW"
    },
    {
        "continent": "AF",
        "capital": "Harare",
        "languages": "en-ZW,sn,nr,nd",
        "geonameId": 878675,
        "south": -22.421998999,
        "isoAlpha3": "ZWE",
        "north": -15.609318999,
        "fipscode": "ZI",
        "population": "13061000",
        "east": 33.0682360000001,
        "isoNumeric": "716",
        "areaInSqKm": "390580.0",
        "countrycode": "ZW",
        "west": 25.2373680000001,
        "countryName": "Zimbabwe",
        "continentName": "Africa",
        "currencycode": "ZWL"
    }
]
const country_with_id = [
    {
        "id": "44",
        "continent_id": "1",
        "code": "CHN",
        "name": "China",
        "full_name": "People's Republic of China",
        "cname": "中国",
        "full_cname": "中华人民共和国",
        "lower_name": "people's republic of china"
    },
    {
        "id": "1",
        "continent_id": "7",
        "code": "ABW",
        "name": "Aruba",
        "full_name": "Aruba",
        "cname": "阿鲁巴岛",
        "full_cname": "阿鲁巴",
        "lower_name": "aruba"
    },
    {
        "id": "2",
        "continent_id": "1",
        "code": "AFG",
        "name": "Afghanistan",
        "full_name": "the Islamic Republic of Afghanistan",
        "cname": "阿富汗",
        "full_cname": "阿富汗斯坦伊斯兰共和国",
        "lower_name": "the islamic republic of afghanistan"
    },
    {
        "id": "3",
        "continent_id": "3",
        "code": "AGO",
        "name": "Angola",
        "full_name": "the Republic of Angola",
        "cname": "安哥拉",
        "full_cname": "安哥拉共和国",
        "lower_name": "the republic of angola"
    },
    {
        "id": "4",
        "continent_id": "",
        "code": "AIA",
        "name": "",
        "full_name": "",
        "cname": "安圭拉",
        "full_cname": "安圭拉",
        "lower_name": ""
    },
    {
        "id": "5",
        "continent_id": "",
        "code": "ALA",
        "name": "",
        "full_name": "",
        "cname": "奥兰群岛",
        "full_cname": "奥兰群岛",
        "lower_name": ""
    },
    {
        "id": "6",
        "continent_id": "2",
        "code": "ALB",
        "name": "Albania",
        "full_name": "The Republic of Albania",
        "cname": "阿尔巴尼亚",
        "full_cname": "阿尔巴尼亚共和国",
        "lower_name": "the republic of albania"
    },
    {
        "id": "7",
        "continent_id": "2",
        "code": "AND",
        "name": "Andorra",
        "full_name": "The Principality of Andorra",
        "cname": "安道尔",
        "full_cname": "安道尔公国",
        "lower_name": "the principality of andorra"
    },
    {
        "id": "9",
        "continent_id": "1",
        "code": "ARE",
        "name": "United Arab Emirates",
        "full_name": "The United Arab Emirates",
        "cname": "阿联酋",
        "full_cname": "阿拉伯联合酋长国",
        "lower_name": "the united arab emirates"
    },
    {
        "id": "10",
        "continent_id": "7",
        "code": "ARG",
        "name": "Argentina",
        "full_name": "The Republic of Argentina",
        "cname": "阿根廷",
        "full_cname": "阿根廷共和国",
        "lower_name": "the republic of argentina"
    },
    {
        "id": "11",
        "continent_id": "2",
        "code": "ARM",
        "name": "Armenia",
        "full_name": "The Republic of Armenia",
        "cname": "亚美尼亚",
        "full_cname": "亚美尼亚共和国",
        "lower_name": "the republic of armenia"
    },
    {
        "id": "13",
        "continent_id": "",
        "code": "ASM",
        "name": "",
        "full_name": "",
        "cname": "美属萨摩亚",
        "full_cname": "美属萨摩亚",
        "lower_name": ""
    },
    {
        "id": "14",
        "continent_id": "",
        "code": "ATA",
        "name": "",
        "full_name": "",
        "cname": "南极洲",
        "full_cname": "南极洲",
        "lower_name": ""
    },
    {
        "id": "15",
        "continent_id": "",
        "code": "ATF",
        "name": "",
        "full_name": "",
        "cname": "法属南部领地",
        "full_cname": "法属南部领地",
        "lower_name": ""
    },
    {
        "id": "16",
        "continent_id": "7",
        "code": "ATG",
        "name": "Antigua and Barbuda",
        "full_name": "Antigua and Barbuda",
        "cname": "安提瓜和巴布达",
        "full_cname": "安提瓜和巴布达",
        "lower_name": "antigua and barbuda"
    },
    {
        "id": "17",
        "continent_id": "4",
        "code": "AUS",
        "name": "Australia",
        "full_name": "The Commonwealth of Australia",
        "cname": "澳大利亚",
        "full_cname": "澳大利亚联邦",
        "lower_name": "the commonwealth of australia"
    },
    {
        "id": "18",
        "continent_id": "2",
        "code": "AUT",
        "name": "Austria",
        "full_name": "The Republic Of Austria",
        "cname": "奥地利",
        "full_cname": "奥地利共和国",
        "lower_name": "the republic of austria"
    },
    {
        "id": "19",
        "continent_id": "2",
        "code": "AZE",
        "name": "Azerbaijan",
        "full_name": "The Republic of Azerbaijan",
        "cname": "阿塞拜疆",
        "full_cname": "阿塞拜疆共和国",
        "lower_name": "the republic of azerbaijan"
    },
    {
        "id": "20",
        "continent_id": "3",
        "code": "BDI",
        "name": "Burundi",
        "full_name": "The Republic of Burundi",
        "cname": "布隆迪",
        "full_cname": "布隆迪共和国",
        "lower_name": "the republic of burundi"
    },
    {
        "id": "21",
        "continent_id": "2",
        "code": "BEL",
        "name": "Belgium",
        "full_name": "The Kingdom Of Belgium",
        "cname": "比利时",
        "full_cname": "比利时王国",
        "lower_name": "the kingdom of belgium"
    },
    {
        "id": "22",
        "continent_id": "3",
        "code": "BEN",
        "name": "Benin",
        "full_name": "the Republic of Benin ",
        "cname": "贝宁",
        "full_cname": "贝宁共和国",
        "lower_name": "the republic of benin "
    },
    {
        "id": "23",
        "continent_id": "3",
        "code": "BFA",
        "name": "Burkina Faso",
        "full_name": "Burkina Faso",
        "cname": "布基纳法索",
        "full_cname": "布基纳法索",
        "lower_name": "burkina faso"
    },
    {
        "id": "24",
        "continent_id": "1",
        "code": "BGD",
        "name": "Bangladesh",
        "full_name": "People's Republic of Bangladesh",
        "cname": "孟加拉国",
        "full_cname": "孟加拉人民共和国",
        "lower_name": "people's republic of bangladesh"
    },
    {
        "id": "25",
        "continent_id": "2",
        "code": "BGR",
        "name": "Bulgaria",
        "full_name": "The Republic of Bulgaria",
        "cname": "保加利亚",
        "full_cname": "保加利亚共和国",
        "lower_name": "the republic of bulgaria"
    },
    {
        "id": "26",
        "continent_id": "1",
        "code": "BHR",
        "name": "Bahrian",
        "full_name": "The Kingdom of Bahrain",
        "cname": "巴林",
        "full_cname": "巴林王国",
        "lower_name": "the kingdom of bahrain"
    },
    {
        "id": "27",
        "continent_id": "7",
        "code": "BHS",
        "name": "Bahamas",
        "full_name": "The Commonwealth of The Bahamas",
        "cname": "巴哈马",
        "full_cname": "巴哈马国",
        "lower_name": "the commonwealth of the bahamas"
    },
    {
        "id": "28",
        "continent_id": "2",
        "code": "BIH",
        "name": "Bosnia Hercegovina",
        "full_name": "Bosnia and Herzegovina",
        "cname": "波斯尼亚和黑塞哥维那",
        "full_cname": "波斯尼亚和黑塞哥维那",
        "lower_name": "bosnia and herzegovina"
    },
    {
        "id": "29",
        "continent_id": "2",
        "code": "BLR",
        "name": " Belarus",
        "full_name": "The Republic of Belarus",
        "cname": "白俄罗斯",
        "full_cname": "白俄罗斯共和国",
        "lower_name": "the republic of belarus"
    },
    {
        "id": "30",
        "continent_id": "7",
        "code": "BLZ",
        "name": "Belize",
        "full_name": "Belize",
        "cname": "伯利兹",
        "full_cname": "伯利兹",
        "lower_name": "belize"
    },
    {
        "id": "31",
        "continent_id": "6",
        "code": "BMU",
        "name": "Bermuda",
        "full_name": "Bermuda",
        "cname": "百慕大",
        "full_cname": "百慕大群岛",
        "lower_name": "bermuda"
    },
    {
        "id": "32",
        "continent_id": "7",
        "code": "BOL",
        "name": "Bolivia",
        "full_name": "The Republic of Bolivia",
        "cname": "玻利维亚",
        "full_cname": "玻利维亚共和国",
        "lower_name": "the republic of bolivia"
    },
    {
        "id": "33",
        "continent_id": "7",
        "code": "BRA",
        "name": "Brazil",
        "full_name": "The Federative Republic of Brazil",
        "cname": "巴西",
        "full_cname": "巴西联邦共和国",
        "lower_name": "the federative republic of brazil"
    },
    {
        "id": "34",
        "continent_id": "7",
        "code": "BRB",
        "name": "Barbados",
        "full_name": "Barbados",
        "cname": "巴巴多斯",
        "full_cname": "巴巴多斯",
        "lower_name": "barbados"
    },
    {
        "id": "35",
        "continent_id": "1",
        "code": "BRN",
        "name": "Brunei",
        "full_name": "Brunei Darussalam",
        "cname": "文莱",
        "full_cname": "文莱达鲁萨兰国",
        "lower_name": "brunei darussalam"
    },
    {
        "id": "36",
        "continent_id": "1",
        "code": "BTN",
        "name": "Bhutan",
        "full_name": "Kingdom of Bhutan",
        "cname": "不丹",
        "full_cname": "不丹王国",
        "lower_name": "kingdom of bhutan"
    },
    {
        "id": "37",
        "continent_id": "",
        "code": "BVT",
        "name": "",
        "full_name": "",
        "cname": "布韦岛",
        "full_cname": "布韦岛",
        "lower_name": ""
    },
    {
        "id": "38",
        "continent_id": "3",
        "code": "BWA",
        "name": "Botswana",
        "full_name": "The Republic of Botswana",
        "cname": "博茨瓦纳",
        "full_cname": "博茨瓦纳共和国",
        "lower_name": "the republic of botswana"
    },
    {
        "id": "39",
        "continent_id": "3",
        "code": "CAF",
        "name": "Central African",
        "full_name": "The Central African Republic",
        "cname": "中非",
        "full_cname": "中非共和国",
        "lower_name": "the central african republic"
    },
    {
        "id": "40",
        "continent_id": "6",
        "code": "CAN",
        "name": "Canada",
        "full_name": "Canada",
        "cname": "加拿大",
        "full_cname": "加拿大",
        "lower_name": "canada"
    },
    {
        "id": "41",
        "continent_id": "",
        "code": "CCK",
        "name": "",
        "full_name": "",
        "cname": "科科斯群岛",
        "full_cname": "科科斯群岛",
        "lower_name": ""
    },
    {
        "id": "42",
        "continent_id": "2",
        "code": "CHE",
        "name": "Switzerland",
        "full_name": "Swiss Confederation",
        "cname": "瑞士",
        "full_cname": "瑞士联邦",
        "lower_name": "swiss confederation"
    },
    {
        "id": "43",
        "continent_id": "7",
        "code": "CHL",
        "name": "Chile",
        "full_name": "Republic of Chile",
        "cname": "智利",
        "full_cname": "智利共和国",
        "lower_name": "republic of chile"
    },
    {
        "id": "45",
        "continent_id": "3",
        "code": "CIV",
        "name": "Cote d'lvoire",
        "full_name": "the Republic of Cote d'ivoire",
        "cname": "科特迪瓦",
        "full_cname": "科特迪瓦共和国",
        "lower_name": "the republic of cote d'ivoire"
    },
    {
        "id": "46",
        "continent_id": "3",
        "code": "CMR",
        "name": "Cameroon",
        "full_name": "the Republic of Cameroon",
        "cname": "喀麦隆",
        "full_cname": "喀麦隆共和国",
        "lower_name": "the republic of cameroon"
    },
    {
        "id": "47",
        "continent_id": "3",
        "code": "COD",
        "name": "DR Congo",
        "full_name": "Democratic Republic of the Congo",
        "cname": "民主刚果",
        "full_cname": "刚果民主共和国",
        "lower_name": "democratic republic of the congo"
    },
    {
        "id": "48",
        "continent_id": "3",
        "code": "COG",
        "name": "Congo",
        "full_name": "Republic of the Congo",
        "cname": "刚果",
        "full_cname": "刚果共和国",
        "lower_name": "republic of the congo"
    },
    {
        "id": "49",
        "continent_id": "4",
        "code": "COK",
        "name": "Cook Is",
        "full_name": "The Cook Islands",
        "cname": "库克群岛",
        "full_cname": "库克群岛",
        "lower_name": "the cook islands"
    },
    {
        "id": "50",
        "continent_id": "7",
        "code": "COL",
        "name": "Colombia",
        "full_name": "The Republic of Colombia",
        "cname": "哥伦比亚",
        "full_cname": "哥伦比亚共和国",
        "lower_name": "the republic of colombia"
    },
    {
        "id": "51",
        "continent_id": "3",
        "code": "COM",
        "name": "Comoros",
        "full_name": "Union of Comoros",
        "cname": "科摩罗",
        "full_cname": "科摩罗联盟",
        "lower_name": "union of comoros"
    },
    {
        "id": "52",
        "continent_id": "3",
        "code": "CPV",
        "name": "Cape Verde",
        "full_name": "The Republic of Cape Verde",
        "cname": "佛得角",
        "full_cname": "佛得角共和国",
        "lower_name": "the republic of cape verde"
    },
    {
        "id": "53",
        "continent_id": "6",
        "code": "CRI",
        "name": "Costa Rica",
        "full_name": "Republic of Costa Rica",
        "cname": "哥斯达黎加",
        "full_cname": "哥斯达黎加共和国",
        "lower_name": "republic of costa rica"
    },
    {
        "id": "54",
        "continent_id": "6",
        "code": "CUB",
        "name": "Cuba",
        "full_name": "The Republic of Cuba",
        "cname": "古巴",
        "full_cname": "古巴共和国",
        "lower_name": "the republic of cuba"
    },
    {
        "id": "55",
        "continent_id": "",
        "code": "CXR",
        "name": "",
        "full_name": "",
        "cname": "圣诞岛",
        "full_cname": "圣诞岛",
        "lower_name": ""
    },
    {
        "id": "56",
        "continent_id": "7",
        "code": "CYM",
        "name": "Cayman Is",
        "full_name": "Cayman Islands",
        "cname": "开曼群岛",
        "full_cname": "开曼群岛",
        "lower_name": "cayman islands"
    },
    {
        "id": "57",
        "continent_id": "2",
        "code": "CYP",
        "name": "Cyprus",
        "full_name": "the Republic of Cyprus",
        "cname": "塞浦路斯",
        "full_cname": "塞浦路斯共和国",
        "lower_name": "the republic of cyprus"
    },
    {
        "id": "58",
        "continent_id": "2",
        "code": "CZE",
        "name": "Czech",
        "full_name": "The Czech Republic",
        "cname": "捷克",
        "full_cname": "捷克共和国",
        "lower_name": "the czech republic"
    },
    {
        "id": "59",
        "continent_id": "2",
        "code": "DEU",
        "name": "Germany",
        "full_name": "The Federal Republic of Germany",
        "cname": "德国",
        "full_cname": "德意志联邦共和国",
        "lower_name": "the federal republic of germany"
    },
    {
        "id": "60",
        "continent_id": "3",
        "code": "DJI",
        "name": "Djibouti",
        "full_name": "The Republic of Djibouti",
        "cname": "吉布提",
        "full_cname": "吉布提共和国",
        "lower_name": "the republic of djibouti"
    },
    {
        "id": "61",
        "continent_id": "6",
        "code": "DMA",
        "name": "Dominica",
        "full_name": "The Commonwealth of Dominica",
        "cname": "多米尼克",
        "full_cname": "多米尼克国",
        "lower_name": "the commonwealth of dominica"
    },
    {
        "id": "62",
        "continent_id": "2",
        "code": "DNK",
        "name": "Denmark",
        "full_name": "The Kingdom of Denmark",
        "cname": "丹麦",
        "full_cname": "丹麦王国",
        "lower_name": "the kingdom of denmark"
    },
    {
        "id": "63",
        "continent_id": "6",
        "code": "DOM",
        "name": "Dominican",
        "full_name": "The Dominican Republic",
        "cname": "多米尼加",
        "full_cname": "多米尼加共和国",
        "lower_name": "the dominican republic"
    },
    {
        "id": "64",
        "continent_id": "3",
        "code": "DZA",
        "name": "Algeria",
        "full_name": "People's Democratic Republic of Algeria",
        "cname": "阿尔及利亚",
        "full_cname": "阿尔及利亚民主人民共和国",
        "lower_name": "people's democratic republic of algeria"
    },
    {
        "id": "65",
        "continent_id": "7",
        "code": "ECU",
        "name": "Ecuador",
        "full_name": "The Republic of Ecuador",
        "cname": "厄瓜多尔",
        "full_cname": "厄瓜多尔共和国",
        "lower_name": "the republic of ecuador"
    },
    {
        "id": "66",
        "continent_id": "3",
        "code": "EGY",
        "name": "Egypt",
        "full_name": "the Arab Republic of Egypt ",
        "cname": "埃及",
        "full_cname": "阿拉伯埃及共和国",
        "lower_name": "the arab republic of egypt "
    },
    {
        "id": "67",
        "continent_id": "3",
        "code": "ERI",
        "name": "Eritrea",
        "full_name": "the Commonwealth of Eritrea",
        "cname": "厄立特里亚",
        "full_cname": "厄立特里亚国",
        "lower_name": "the commonwealth of eritrea"
    },
    {
        "id": "68",
        "continent_id": "2",
        "code": "ESP",
        "name": "Spain",
        "full_name": "The Kingdom of Spain",
        "cname": "西班牙",
        "full_cname": "西班牙王国",
        "lower_name": "the kingdom of spain"
    },
    {
        "id": "69",
        "continent_id": "2",
        "code": "EST",
        "name": "Estonia",
        "full_name": "Republic of Estonia",
        "cname": "爱沙尼亚",
        "full_cname": "爱沙尼亚共和国",
        "lower_name": "republic of estonia"
    },
    {
        "id": "70",
        "continent_id": "3",
        "code": "ETH",
        "name": "Ethiopia",
        "full_name": "The Federal Democratic Republic of Ethiopia",
        "cname": "埃塞俄比亚",
        "full_cname": "埃塞俄比亚联邦民主共和国",
        "lower_name": "the federal democratic republic of ethiopia"
    },
    {
        "id": "71",
        "continent_id": "2",
        "code": "FIN",
        "name": "Finland",
        "full_name": "The Republic of Finland",
        "cname": "芬兰",
        "full_cname": "芬兰共和国",
        "lower_name": "the republic of finland"
    },
    {
        "id": "72",
        "continent_id": "4",
        "code": "FJI",
        "name": "Fiji",
        "full_name": "The Republic of Fiji",
        "cname": "斐济",
        "full_cname": "斐济共和国",
        "lower_name": "the republic of fiji"
    },
    {
        "id": "73",
        "continent_id": "",
        "code": "FLK",
        "name": "",
        "full_name": "",
        "cname": "弗兰克群岛",
        "full_cname": "弗兰克群岛",
        "lower_name": ""
    },
    {
        "id": "74",
        "continent_id": "2",
        "code": "FRA",
        "name": "France",
        "full_name": "The French Republic",
        "cname": "法国",
        "full_cname": "法兰西共和国",
        "lower_name": "the french republic"
    },
    {
        "id": "75",
        "continent_id": "",
        "code": "FRO",
        "name": "",
        "full_name": "",
        "cname": "法罗群岛",
        "full_cname": "法罗群岛",
        "lower_name": ""
    },
    {
        "id": "76",
        "continent_id": "4",
        "code": "FSM",
        "name": "Micronesia",
        "full_name": "Federated States of Micronesia",
        "cname": "密克罗尼西亚联邦",
        "full_cname": "密克罗尼西亚联邦",
        "lower_name": "federated states of micronesia"
    },
    {
        "id": "77",
        "continent_id": "3",
        "code": "GAB",
        "name": "Gabon",
        "full_name": "The Gabonese Republic",
        "cname": "加蓬",
        "full_cname": "加蓬共和国",
        "lower_name": "the gabonese republic"
    },
    {
        "id": "78",
        "continent_id": "2",
        "code": "GBR",
        "name": "United Kingdom",
        "full_name": "The United Kingdom of Great Britain and Northern Ireland",
        "cname": "英国",
        "full_cname": "大不列颠及北爱尔兰联合王国",
        "lower_name": "the united kingdom of great britain and northern ireland"
    },
    {
        "id": "79",
        "continent_id": "2",
        "code": "GEO",
        "name": "Georgia",
        "full_name": "Georgia",
        "cname": "格鲁吉亚",
        "full_cname": "格鲁吉亚",
        "lower_name": "georgia"
    },
    {
        "id": "80",
        "continent_id": "",
        "code": "GGY",
        "name": "",
        "full_name": "",
        "cname": "格恩西岛",
        "full_cname": "格恩西岛",
        "lower_name": ""
    },
    {
        "id": "81",
        "continent_id": "3",
        "code": "GHA",
        "name": "Ghana",
        "full_name": "The Republic of Ghana",
        "cname": "加纳",
        "full_cname": "加纳共和国",
        "lower_name": "the republic of ghana"
    },
    {
        "id": "82",
        "continent_id": "2",
        "code": "GIB",
        "name": "Gibraltar",
        "full_name": "Gibraltar",
        "cname": "直布罗陀",
        "full_cname": "直布罗陀",
        "lower_name": "gibraltar"
    },
    {
        "id": "83",
        "continent_id": "3",
        "code": "GIN",
        "name": "Guinea",
        "full_name": "The Republic of Guinea",
        "cname": "几内亚",
        "full_cname": "几内亚共和国",
        "lower_name": "the republic of guinea"
    },
    {
        "id": "84",
        "continent_id": "",
        "code": "GLP",
        "name": "",
        "full_name": "",
        "cname": "瓜德罗普",
        "full_cname": "瓜德罗普",
        "lower_name": ""
    },
    {
        "id": "85",
        "continent_id": "3",
        "code": "GMB",
        "name": "Gambia",
        "full_name": "Islamic Republic of Gambia",
        "cname": "冈比亚",
        "full_cname": "冈比亚伊斯兰共和国",
        "lower_name": "islamic republic of gambia"
    },
    {
        "id": "86",
        "continent_id": "3",
        "code": "GNB",
        "name": "Guinea Bissau",
        "full_name": "The Republic of Guinea-Bissau",
        "cname": "几内亚比绍",
        "full_cname": "几内亚比绍共和国",
        "lower_name": "the republic of guinea-bissau"
    },
    {
        "id": "87",
        "continent_id": "2",
        "code": "GRC",
        "name": "Greece",
        "full_name": "The Hellenic Republic",
        "cname": "希腊",
        "full_cname": "希腊共和国",
        "lower_name": "the hellenic republic"
    },
    {
        "id": "88",
        "continent_id": "7",
        "code": "GRD",
        "name": "Grenada",
        "full_name": "Grenada",
        "cname": "格林纳达",
        "full_cname": "格林纳达",
        "lower_name": "grenada"
    },
    {
        "id": "89",
        "continent_id": "6",
        "code": "GRL",
        "name": "Greenland",
        "full_name": "Greenland",
        "cname": "格陵兰",
        "full_cname": "格陵兰",
        "lower_name": "greenland"
    },
    {
        "id": "90",
        "continent_id": "6",
        "code": "GTM",
        "name": "Guatemala",
        "full_name": "The Republic of Guatemala",
        "cname": "危地马拉",
        "full_cname": "危地马拉共和国",
        "lower_name": "the republic of guatemala"
    },
    {
        "id": "91",
        "continent_id": "",
        "code": "GUF",
        "name": "",
        "full_name": "",
        "cname": "法属圭亚那",
        "full_cname": "法属圭亚那",
        "lower_name": ""
    },
    {
        "id": "92",
        "continent_id": "",
        "code": "GUM",
        "name": "",
        "full_name": "",
        "cname": "关岛",
        "full_cname": "关岛",
        "lower_name": ""
    },
    {
        "id": "93",
        "continent_id": "7",
        "code": "GUY",
        "name": "Guyana",
        "full_name": "The Republic of Guyana",
        "cname": "圭亚那",
        "full_cname": "圭亚那共和国",
        "lower_name": "the republic of guyana"
    },
    {
        "id": "94",
        "continent_id": "",
        "code": "HMD",
        "name": "",
        "full_name": "",
        "cname": "赫德和麦克唐纳群岛",
        "full_cname": "赫德和麦克唐纳群岛",
        "lower_name": ""
    },
    {
        "id": "95",
        "continent_id": "6",
        "code": "HND",
        "name": "Honduras",
        "full_name": "Republic of Honduras",
        "cname": "洪都拉斯",
        "full_cname": "洪都拉斯共和国",
        "lower_name": "republic of honduras"
    },
    {
        "id": "96",
        "continent_id": "2",
        "code": "HRV",
        "name": "Croatia",
        "full_name": "The Republic of Croatia",
        "cname": "克罗地亚",
        "full_cname": "克罗地亚共和国",
        "lower_name": "the republic of croatia"
    },
    {
        "id": "97",
        "continent_id": "7",
        "code": "HTI",
        "name": "Haiti",
        "full_name": "The Republic of Haiti",
        "cname": "海地",
        "full_cname": "海地共和国",
        "lower_name": "the republic of haiti"
    },
    {
        "id": "98",
        "continent_id": "2",
        "code": "HUN",
        "name": "Hungary",
        "full_name": "Hungary",
        "cname": "匈牙利",
        "full_cname": "匈牙利",
        "lower_name": "hungary"
    },
    {
        "id": "99",
        "continent_id": "1",
        "code": "IDN",
        "name": "Indonesia",
        "full_name": "The Republic of Indonesia",
        "cname": "印度尼西亚",
        "full_cname": "印度尼西亚共和国",
        "lower_name": "the republic of indonesia"
    },
    {
        "id": "100",
        "continent_id": "",
        "code": "IMN",
        "name": "",
        "full_name": "",
        "cname": "曼岛",
        "full_cname": "曼岛",
        "lower_name": ""
    },
    {
        "id": "101",
        "continent_id": "1",
        "code": "IND",
        "name": "India",
        "full_name": "The Republic of India",
        "cname": "印度",
        "full_cname": "印度共和国",
        "lower_name": "the republic of india"
    },
    {
        "id": "102",
        "continent_id": "",
        "code": "IOT",
        "name": "",
        "full_name": "",
        "cname": "英属印度洋领地",
        "full_cname": "英属印度洋领地",
        "lower_name": ""
    },
    {
        "id": "103",
        "continent_id": "2",
        "code": "IRL",
        "name": "Ireland",
        "full_name": "The Republic of Ireland",
        "cname": "爱尔兰",
        "full_cname": "爱尔兰共和国",
        "lower_name": "the republic of ireland"
    },
    {
        "id": "104",
        "continent_id": "1",
        "code": "IRN",
        "name": "Iran",
        "full_name": "The Islamic Republic of Iran",
        "cname": "伊朗",
        "full_cname": "伊朗伊斯兰共和国",
        "lower_name": "the islamic republic of iran"
    },
    {
        "id": "105",
        "continent_id": "1",
        "code": "IRQ",
        "name": "Iraq",
        "full_name": "Republic Of Iraq",
        "cname": "伊拉克",
        "full_cname": "伊拉克共和国",
        "lower_name": "republic of iraq"
    },
    {
        "id": "106",
        "continent_id": "2",
        "code": "ISL",
        "name": "Iceland",
        "full_name": "The Republic of Iceland",
        "cname": "冰岛",
        "full_cname": "冰岛共和国",
        "lower_name": "the republic of iceland"
    },
    {
        "id": "107",
        "continent_id": "1",
        "code": "ISR",
        "name": "Israel",
        "full_name": "The State of Israel",
        "cname": "以色列",
        "full_cname": "以色列国",
        "lower_name": "the state of israel"
    },
    {
        "id": "108",
        "continent_id": "2",
        "code": "ITA",
        "name": "Italy",
        "full_name": "The Republic of Italy",
        "cname": "意大利",
        "full_cname": "意大利共和国",
        "lower_name": "the republic of italy"
    },
    {
        "id": "109",
        "continent_id": "7",
        "code": "JAM",
        "name": "Jamaica",
        "full_name": "Jamaica",
        "cname": "牙买加",
        "full_cname": "牙买加",
        "lower_name": "jamaica"
    },
    {
        "id": "110",
        "continent_id": "",
        "code": "JEY",
        "name": "",
        "full_name": "",
        "cname": "泽西岛",
        "full_cname": "泽西岛",
        "lower_name": ""
    },
    {
        "id": "111",
        "continent_id": "1",
        "code": "JOR",
        "name": "Jordan",
        "full_name": "The Hashemite Kingdom of Jordan",
        "cname": "约旦",
        "full_cname": "约旦哈希姆王国",
        "lower_name": "the hashemite kingdom of jordan"
    },
    {
        "id": "112",
        "continent_id": "1",
        "code": "JPN",
        "name": "Japan",
        "full_name": "Japan",
        "cname": "日本",
        "full_cname": "日本国",
        "lower_name": "japan"
    },
    {
        "id": "113",
        "continent_id": "1",
        "code": "KAZ",
        "name": "Kazakhstan",
        "full_name": "The Republic of Kazakhstan",
        "cname": "哈萨克斯坦",
        "full_cname": "哈萨克斯坦共和国",
        "lower_name": "the republic of kazakhstan"
    },
    {
        "id": "114",
        "continent_id": "3",
        "code": "KEN",
        "name": "Kenya",
        "full_name": "The Republic of Kenya",
        "cname": "肯尼亚",
        "full_cname": "肯尼亚共和国",
        "lower_name": "the republic of kenya"
    },
    {
        "id": "115",
        "continent_id": "1",
        "code": "KGZ",
        "name": "Kirghizia",
        "full_name": "The Kyrgyz Republic",
        "cname": "吉尔吉斯斯坦",
        "full_cname": "吉尔吉斯共和国",
        "lower_name": "the kyrgyz republic"
    },
    {
        "id": "116",
        "continent_id": "1",
        "code": "KHM",
        "name": "Cambodia",
        "full_name": "Kingdom of Cambodia",
        "cname": "柬埔寨",
        "full_cname": "柬埔寨王国",
        "lower_name": "kingdom of cambodia"
    },
    {
        "id": "117",
        "continent_id": "4",
        "code": "KIR",
        "name": "Kiribati",
        "full_name": "The Republic of Kiribati",
        "cname": "基里巴斯",
        "full_cname": "基里巴斯共和国",
        "lower_name": "the republic of kiribati"
    },
    {
        "id": "118",
        "continent_id": "7",
        "code": "KNA",
        "name": "St Kitts-Nevis",
        "full_name": "The Federation of Saint Kitts and Nevis",
        "cname": "圣其茨-尼维斯",
        "full_cname": "圣基茨和尼维斯联邦",
        "lower_name": "the federation of saint kitts and nevis"
    },
    {
        "id": "119",
        "continent_id": "1",
        "code": "KOR",
        "name": "Korea",
        "full_name": "Republic of Korea",
        "cname": "韩国",
        "full_cname": "大韩民国",
        "lower_name": "republic of korea"
    },
    {
        "id": "120",
        "continent_id": "1",
        "code": "KWT",
        "name": "Kuwait",
        "full_name": "The State of Kuwait",
        "cname": "科威特",
        "full_cname": "科威特国",
        "lower_name": "the state of kuwait"
    },
    {
        "id": "121",
        "continent_id": "1",
        "code": "LAO",
        "name": "Laos",
        "full_name": "Lao People's Democratic Republic",
        "cname": "老挝",
        "full_cname": "老挝人民民主共和国",
        "lower_name": "lao people's democratic republic"
    },
    {
        "id": "122",
        "continent_id": "1",
        "code": "LBN",
        "name": "Lebanon",
        "full_name": "The Republic of Lebanon",
        "cname": "黎巴嫩",
        "full_cname": "黎巴嫩共和国",
        "lower_name": "the republic of lebanon"
    },
    {
        "id": "123",
        "continent_id": "3",
        "code": "LBR",
        "name": "Liberia",
        "full_name": "The Republic of Liberia",
        "cname": "利比里亚",
        "full_cname": "利比里亚共和国",
        "lower_name": "the republic of liberia"
    },
    {
        "id": "124",
        "continent_id": "3",
        "code": "LBY",
        "name": "Libyan Arab Jm",
        "full_name": "State of Libya",
        "cname": "利比亚",
        "full_cname": "利比亚国",
        "lower_name": "state of libya"
    },
    {
        "id": "125",
        "continent_id": "",
        "code": "LCA",
        "name": "",
        "full_name": "",
        "cname": "圣卢西亚",
        "full_cname": "圣卢西亚",
        "lower_name": ""
    },
    {
        "id": "126",
        "continent_id": "2",
        "code": "LIE",
        "name": "Liechtenstein",
        "full_name": "Principality of Liechtenstein",
        "cname": "列支敦士登",
        "full_cname": "列支敦士登公国",
        "lower_name": "principality of liechtenstein"
    },
    {
        "id": "127",
        "continent_id": "1",
        "code": "LKA",
        "name": "Sri Lanka",
        "full_name": "The Democratic Socialist Republic of Sri Lanka",
        "cname": "斯里兰卡",
        "full_cname": "斯里兰卡民主社会主义共和国",
        "lower_name": "the democratic socialist republic of sri lanka"
    },
    {
        "id": "128",
        "continent_id": "3",
        "code": "LSO",
        "name": "Lesotho",
        "full_name": "The Kingdom of Lesotho",
        "cname": "莱索托",
        "full_cname": "莱索托王国",
        "lower_name": "the kingdom of lesotho"
    },
    {
        "id": "129",
        "continent_id": "2",
        "code": "LTU",
        "name": "Lithuania",
        "full_name": "The Republic of Lithuania",
        "cname": "立陶宛",
        "full_cname": "立陶宛共和国",
        "lower_name": "the republic of lithuania"
    },
    {
        "id": "130",
        "continent_id": "2",
        "code": "LUX",
        "name": "Luxembourg",
        "full_name": "The Grand Duchy of Luxembourg",
        "cname": "卢森堡",
        "full_cname": "卢森堡大公国",
        "lower_name": "the grand duchy of luxembourg"
    },
    {
        "id": "131",
        "continent_id": "2",
        "code": "LVA",
        "name": "Latvia",
        "full_name": "Republic of Latvia",
        "cname": "拉脱维亚",
        "full_cname": "拉脱维亚共和国",
        "lower_name": "republic of latvia"
    },
    {
        "id": "132",
        "continent_id": "3",
        "code": "MAR",
        "name": "Morocco",
        "full_name": "The Kingdom of Morocco",
        "cname": "摩洛哥",
        "full_cname": "摩洛哥王国",
        "lower_name": "the kingdom of morocco"
    },
    {
        "id": "133",
        "continent_id": "2",
        "code": "MCO",
        "name": "Monaco",
        "full_name": "The Principality of Monaco",
        "cname": "摩纳哥",
        "full_cname": "摩纳哥公国",
        "lower_name": "the principality of monaco"
    },
    {
        "id": "134",
        "continent_id": "2",
        "code": "MDA",
        "name": "Moldavia",
        "full_name": "The Republic of Moldova",
        "cname": "摩尔多瓦",
        "full_cname": "摩尔多瓦共和国",
        "lower_name": "the republic of moldova"
    },
    {
        "id": "135",
        "continent_id": "3",
        "code": "MDG",
        "name": "Madagascar",
        "full_name": "the Republic of Madagascar ",
        "cname": "马达加斯加",
        "full_cname": "马达加斯加共和国",
        "lower_name": "the republic of madagascar "
    },
    {
        "id": "136",
        "continent_id": "1",
        "code": "MDV",
        "name": "Maldives",
        "full_name": "The Republic of Maldives",
        "cname": "马尔代夫",
        "full_cname": "马尔代夫共和国",
        "lower_name": "the republic of maldives"
    },
    {
        "id": "137",
        "continent_id": "6",
        "code": "MEX",
        "name": "Mexico",
        "full_name": "The United States of Mexico",
        "cname": "墨西哥",
        "full_cname": "墨西哥合众国",
        "lower_name": "the united states of mexico"
    },
    {
        "id": "138",
        "continent_id": "4",
        "code": "MHL",
        "name": "Marshall Is Rep",
        "full_name": "The Republic of Marshall Island ",
        "cname": "马绍尔群岛",
        "full_cname": "马绍尔群岛共和国",
        "lower_name": "the republic of marshall island "
    },
    {
        "id": "139",
        "continent_id": "2",
        "code": "MKD",
        "name": "Macedonia",
        "full_name": "The Republic of Macedonia",
        "cname": "马其顿",
        "full_cname": "马其顿共和国",
        "lower_name": "the republic of macedonia"
    },
    {
        "id": "140",
        "continent_id": "3",
        "code": "MLI",
        "name": "Mali",
        "full_name": "The Republic of Mali",
        "cname": "马里",
        "full_cname": "马里共和国",
        "lower_name": "the republic of mali"
    },
    {
        "id": "141",
        "continent_id": "2",
        "code": "MLT",
        "name": "Malta",
        "full_name": "Republic of Malta",
        "cname": "马耳他",
        "full_cname": "马耳他共和国",
        "lower_name": "republic of malta"
    },
    {
        "id": "142",
        "continent_id": "1",
        "code": "MMR",
        "name": "Myanmar",
        "full_name": "Republic Of The Union Of Myanmar",
        "cname": "缅甸",
        "full_cname": "缅甸联邦共和国",
        "lower_name": "republic of the union of myanmar"
    },
    {
        "id": "143",
        "continent_id": "1",
        "code": "MNG",
        "name": "Mongolia",
        "full_name": "Mongolia",
        "cname": "蒙古",
        "full_cname": "蒙古国",
        "lower_name": "mongolia"
    },
    {
        "id": "144",
        "continent_id": "",
        "code": "MNP",
        "name": "",
        "full_name": "",
        "cname": "北马里亚纳群岛",
        "full_cname": "北马里亚纳群岛",
        "lower_name": ""
    },
    {
        "id": "145",
        "continent_id": "3",
        "code": "MOZ",
        "name": "Mozambique",
        "full_name": "The Republic of Mozambique",
        "cname": "莫桑比克",
        "full_cname": "莫桑比克共和国",
        "lower_name": "the republic of mozambique"
    },
    {
        "id": "146",
        "continent_id": "3",
        "code": "MRT",
        "name": "Mauritania",
        "full_name": "The Islamic Republic of Mauritania",
        "cname": "毛里塔尼亚",
        "full_cname": "毛里塔尼亚伊斯兰共和国",
        "lower_name": "the islamic republic of mauritania"
    },
    {
        "id": "147",
        "continent_id": "7",
        "code": "MSR",
        "name": "Montserrat",
        "full_name": "Montserrat",
        "cname": "蒙特塞拉特",
        "full_cname": "蒙特塞拉特岛",
        "lower_name": "montserrat"
    },
    {
        "id": "148",
        "continent_id": "7",
        "code": "MTQ",
        "name": "Martinique",
        "full_name": "Martinique",
        "cname": "马提尼克",
        "full_cname": "马提尼克岛",
        "lower_name": "martinique"
    },
    {
        "id": "149",
        "continent_id": "3",
        "code": "MUS",
        "name": "Mauritius",
        "full_name": "the Republic of Mauritius",
        "cname": "毛里求斯",
        "full_cname": "毛里求斯共和国",
        "lower_name": "the republic of mauritius"
    },
    {
        "id": "150",
        "continent_id": "3",
        "code": "MWI",
        "name": "Malawi",
        "full_name": "The Republic of Malawi",
        "cname": "马拉维",
        "full_cname": "马拉维共和国",
        "lower_name": "the republic of malawi"
    },
    {
        "id": "151",
        "continent_id": "1",
        "code": "MYS",
        "name": "Malaysia",
        "full_name": "Malaysia",
        "cname": "马来西亚",
        "full_cname": "马来西亚联邦",
        "lower_name": "malaysia"
    },
    {
        "id": "152",
        "continent_id": "3",
        "code": "MYT",
        "name": "Mayotte",
        "full_name": "Territorial Collectivity of Mayotte",
        "cname": "马约特岛",
        "full_cname": "马约特岛",
        "lower_name": "territorial collectivity of mayotte"
    },
    {
        "id": "153",
        "continent_id": "3",
        "code": "NAM",
        "name": "Namibia",
        "full_name": "The Republic of Namibia",
        "cname": "纳米比亚",
        "full_cname": "纳米比亚共和国",
        "lower_name": "the republic of namibia"
    },
    {
        "id": "154",
        "continent_id": "4",
        "code": "NCL",
        "name": "New Caledonia",
        "full_name": "New Caledonia",
        "cname": "新喀里多尼亚",
        "full_cname": "新喀里多尼亚",
        "lower_name": "new caledonia"
    },
    {
        "id": "155",
        "continent_id": "3",
        "code": "NER",
        "name": "Niger",
        "full_name": "The Republic of Niger",
        "cname": "尼日尔",
        "full_cname": "尼日尔共和国",
        "lower_name": "the republic of niger"
    },
    {
        "id": "156",
        "continent_id": "",
        "code": "NFK",
        "name": "",
        "full_name": "",
        "cname": "诺福克",
        "full_cname": "诺福克",
        "lower_name": ""
    },
    {
        "id": "157",
        "continent_id": "3",
        "code": "NGA",
        "name": "Nigeria",
        "full_name": "Federal Republic of Nigeria",
        "cname": "尼日利亚",
        "full_cname": "尼日利亚联邦共和国",
        "lower_name": "federal republic of nigeria"
    },
    {
        "id": "158",
        "continent_id": "6",
        "code": "NIC",
        "name": "Nicaragua",
        "full_name": "The Republic of Nicaragua",
        "cname": "尼加拉瓜",
        "full_cname": "尼加拉瓜共和国",
        "lower_name": "the republic of nicaragua"
    },
    {
        "id": "159",
        "continent_id": "",
        "code": "NIU",
        "name": "",
        "full_name": "",
        "cname": "纽埃",
        "full_cname": "纽埃",
        "lower_name": ""
    },
    {
        "id": "160",
        "continent_id": "2",
        "code": "NLD",
        "name": "Netherlands",
        "full_name": "The Kingdom of Netherlands",
        "cname": "荷兰",
        "full_cname": "尼德兰王国",
        "lower_name": "the kingdom of netherlands"
    },
    {
        "id": "161",
        "continent_id": "2",
        "code": "NOR",
        "name": "Norway",
        "full_name": "The Kingdom of Norway",
        "cname": "挪威",
        "full_cname": "挪威王国",
        "lower_name": "the kingdom of norway"
    },
    {
        "id": "162",
        "continent_id": "1",
        "code": "NPL",
        "name": "Nepal",
        "full_name": "Federal Democratic Republic of Nepal",
        "cname": "尼泊尔",
        "full_cname": "尼泊尔联邦民主共和国",
        "lower_name": "federal democratic republic of nepal"
    },
    {
        "id": "163",
        "continent_id": "4",
        "code": "NRU",
        "name": "Nauru",
        "full_name": "The Republic of Nauru",
        "cname": "瑙鲁",
        "full_cname": "瑙鲁共和国",
        "lower_name": "the republic of nauru"
    },
    {
        "id": "164",
        "continent_id": "4",
        "code": "NZL",
        "name": "New Zealand",
        "full_name": "New Zealand",
        "cname": "新西兰",
        "full_cname": "新西兰",
        "lower_name": "new zealand"
    },
    {
        "id": "165",
        "continent_id": "1",
        "code": "OMN",
        "name": "Oman",
        "full_name": "Sultanate of Oman",
        "cname": "阿曼",
        "full_cname": "阿曼苏丹国",
        "lower_name": "sultanate of oman"
    },
    {
        "id": "166",
        "continent_id": "1",
        "code": "PAK",
        "name": "Pakistan",
        "full_name": "the Islamic Republic of Pakistan",
        "cname": "巴基斯坦",
        "full_cname": "巴基斯坦伊斯兰共和国",
        "lower_name": "the islamic republic of pakistan"
    },
    {
        "id": "167",
        "continent_id": "6",
        "code": "PAN",
        "name": "Panama",
        "full_name": "The Republic of Panama",
        "cname": "巴拿马",
        "full_cname": "巴拿马共和国",
        "lower_name": "the republic of panama"
    },
    {
        "id": "168",
        "continent_id": "",
        "code": "PCN",
        "name": "",
        "full_name": "",
        "cname": "皮特凯恩",
        "full_cname": "皮特凯恩",
        "lower_name": ""
    },
    {
        "id": "169",
        "continent_id": "7",
        "code": "PER",
        "name": "Peru",
        "full_name": "The Republic of Peru",
        "cname": "秘鲁",
        "full_cname": "秘鲁共和国",
        "lower_name": "the republic of peru"
    },
    {
        "id": "170",
        "continent_id": "1",
        "code": "PHL",
        "name": "Philippines",
        "full_name": "Republic of the Philippines",
        "cname": "菲律宾",
        "full_cname": "菲律宾共和国",
        "lower_name": "republic of the philippines"
    },
    {
        "id": "171",
        "continent_id": "4",
        "code": "PLW",
        "name": "Palau",
        "full_name": "The Republic of Palau",
        "cname": "帕劳",
        "full_cname": "帕劳共和国",
        "lower_name": "the republic of palau"
    },
    {
        "id": "172",
        "continent_id": "4",
        "code": "PNG",
        "name": "Papua New Guinea",
        "full_name": "The Independent State of Papua New Guinea",
        "cname": "巴布亚新几内亚",
        "full_cname": "巴布亚新几内亚独立国",
        "lower_name": "the independent state of papua new guinea"
    },
    {
        "id": "173",
        "continent_id": "2",
        "code": "POL",
        "name": "Poland",
        "full_name": "The Republic of Poland",
        "cname": "波兰",
        "full_cname": "波兰共和国",
        "lower_name": "the republic of poland"
    },
    {
        "id": "174",
        "continent_id": "6",
        "code": "PRI",
        "name": "Puerto Rico",
        "full_name": "The Commonwealth of Puerto Rico",
        "cname": "波多黎各",
        "full_cname": "波多黎各自由邦",
        "lower_name": "the commonwealth of puerto rico"
    },
    {
        "id": "175",
        "continent_id": "1",
        "code": "PRK",
        "name": "Korea,DPR",
        "full_name": "Democratic People's Republic of Korea",
        "cname": "朝鲜",
        "full_cname": "朝鲜民主主义人民共和国",
        "lower_name": "democratic people's republic of korea"
    },
    {
        "id": "176",
        "continent_id": "2",
        "code": "PRT",
        "name": "Portugal",
        "full_name": "Portugal,the Portuguese Republic",
        "cname": "葡萄牙",
        "full_cname": "葡萄牙共和国",
        "lower_name": "portugal,the portuguese republic"
    },
    {
        "id": "177",
        "continent_id": "7",
        "code": "PRY",
        "name": "Paraguay",
        "full_name": "The Republic of Paraguay",
        "cname": "巴拉圭",
        "full_cname": "巴拉圭共和国",
        "lower_name": "the republic of paraguay"
    },
    {
        "id": "178",
        "continent_id": "1",
        "code": "PSE",
        "name": "Palestine",
        "full_name": "The State of Palestine",
        "cname": "巴勒斯坦",
        "full_cname": "巴勒斯坦国",
        "lower_name": "the state of palestine"
    },
    {
        "id": "179",
        "continent_id": "4",
        "code": "PYF",
        "name": "French Polynesia",
        "full_name": "French Polynesia",
        "cname": "法属玻利尼西亚",
        "full_cname": "法属波利尼西亚",
        "lower_name": "french polynesia"
    },
    {
        "id": "180",
        "continent_id": "1",
        "code": "QAT",
        "name": "Qatar",
        "full_name": "The State of Qatar",
        "cname": "卡塔尔",
        "full_cname": "卡塔尔国",
        "lower_name": "the state of qatar"
    },
    {
        "id": "181",
        "continent_id": "3",
        "code": "REU",
        "name": "Reunion",
        "full_name": "Reunion Island",
        "cname": "留尼汪",
        "full_cname": "留尼汪岛",
        "lower_name": "reunion island"
    },
    {
        "id": "182",
        "continent_id": "2",
        "code": "ROU",
        "name": "Romania",
        "full_name": "Romania",
        "cname": "罗马尼亚",
        "full_cname": "罗马尼亚",
        "lower_name": "romania"
    },
    {
        "id": "183",
        "continent_id": "2",
        "code": "RUS",
        "name": "Russia",
        "full_name": "Russian Federation",
        "cname": "俄罗斯联邦",
        "full_cname": "俄罗斯联邦",
        "lower_name": "russian federation"
    },
    {
        "id": "184",
        "continent_id": "3",
        "code": "RWA",
        "name": "Rwanda",
        "full_name": "the Republic of Rwanda",
        "cname": "卢旺达",
        "full_cname": "卢旺达共和国",
        "lower_name": "the republic of rwanda"
    },
    {
        "id": "185",
        "continent_id": "1",
        "code": "SAU",
        "name": "Saudi Arabia",
        "full_name": "Kingdom of Saudi Arabia",
        "cname": "沙特阿拉伯",
        "full_cname": "沙特阿拉伯王国",
        "lower_name": "kingdom of saudi arabia"
    },
    {
        "id": "187",
        "continent_id": "3",
        "code": "SDN",
        "name": "Sudan",
        "full_name": "The Republic of Sudan",
        "cname": "苏丹",
        "full_cname": "苏丹共和国",
        "lower_name": "the republic of sudan"
    },
    {
        "id": "188",
        "continent_id": "3",
        "code": "SEN",
        "name": "Senegal",
        "full_name": "the Republic of Senegal",
        "cname": "塞内加尔",
        "full_cname": "塞内加尔共和国",
        "lower_name": "the republic of senegal"
    },
    {
        "id": "189",
        "continent_id": "1",
        "code": "SGP",
        "name": "Singapore",
        "full_name": "Republic of Singapore",
        "cname": "新加坡",
        "full_cname": "新加坡共和国",
        "lower_name": "republic of singapore"
    },
    {
        "id": "190",
        "continent_id": "",
        "code": "SGS",
        "name": "",
        "full_name": "",
        "cname": "南乔治亚和南桑德威奇群岛",
        "full_cname": "南乔治亚和南桑德威奇群岛",
        "lower_name": ""
    },
    {
        "id": "191",
        "continent_id": "",
        "code": "SHN",
        "name": "",
        "full_name": "",
        "cname": "圣赫勒拿",
        "full_cname": "圣赫勒拿",
        "lower_name": ""
    },
    {
        "id": "192",
        "continent_id": "",
        "code": "SJM",
        "name": "",
        "full_name": "",
        "cname": "斯瓦尔巴和扬马廷",
        "full_cname": "斯瓦尔巴和扬马廷",
        "lower_name": ""
    },
    {
        "id": "193",
        "continent_id": "4",
        "code": "SLB",
        "name": "Solomon Is",
        "full_name": "Solomon Islands",
        "cname": "所罗门群岛",
        "full_cname": "所罗门群岛",
        "lower_name": "solomon islands"
    },
    {
        "id": "194",
        "continent_id": "3",
        "code": "SLE",
        "name": "Sierra Leone",
        "full_name": "The Republic of Sierra Leone",
        "cname": "塞拉利昂",
        "full_cname": "塞拉利昂共和国",
        "lower_name": "the republic of sierra leone"
    },
    {
        "id": "195",
        "continent_id": "6",
        "code": "SLV",
        "name": "El Salvador",
        "full_name": "The Republic of El Salvador",
        "cname": "萨尔瓦多",
        "full_cname": "萨尔瓦多共和国",
        "lower_name": "the republic of el salvador"
    },
    {
        "id": "196",
        "continent_id": "2",
        "code": "SMR",
        "name": "San Marino",
        "full_name": "The Republic of San Marino",
        "cname": "圣马力诺",
        "full_cname": "圣马力诺共和国",
        "lower_name": "the republic of san marino"
    },
    {
        "id": "197",
        "continent_id": "3",
        "code": "SOM",
        "name": "Somalia",
        "full_name": "The Somalia Democratic Republic",
        "cname": "索马里",
        "full_cname": "索马里联邦共和国",
        "lower_name": "the somalia democratic republic"
    },
    {
        "id": "198",
        "continent_id": "7",
        "code": "SPM",
        "name": "St.Pierre and Miquelon",
        "full_name": "The Islands of st pierre and miquelon",
        "cname": "圣皮埃尔和密克隆",
        "full_cname": "圣皮埃尔和密克隆群岛",
        "lower_name": "the islands of st pierre and miquelon"
    },
    {
        "id": "199",
        "continent_id": "3",
        "code": "STP",
        "name": "Sao Tome and Principe",
        "full_name": "the Democratic Republic Sao Tome and Principe",
        "cname": "圣多美和普林西比",
        "full_cname": "圣多美和普林西比民主共和国",
        "lower_name": "the democratic republic sao tome and principe"
    },
    {
        "id": "200",
        "continent_id": "7",
        "code": "SUR",
        "name": "Suriname",
        "full_name": "The Republic of Suriname",
        "cname": "苏里南",
        "full_cname": "苏里南共和国",
        "lower_name": "the republic of suriname"
    },
    {
        "id": "201",
        "continent_id": "2",
        "code": "SVK",
        "name": "Slovak",
        "full_name": "The Slovak Republic",
        "cname": "斯洛伐克",
        "full_cname": "斯洛伐克共和国",
        "lower_name": "the slovak republic"
    },
    {
        "id": "202",
        "continent_id": "2",
        "code": "SVN",
        "name": "Slovenia",
        "full_name": "The Republic of Slovenia",
        "cname": "斯洛文尼亚",
        "full_cname": "斯洛文尼亚共和国",
        "lower_name": "the republic of slovenia"
    },
    {
        "id": "203",
        "continent_id": "2",
        "code": "SWE",
        "name": "Sweden",
        "full_name": "The Kingdom of Sweden",
        "cname": "瑞典",
        "full_cname": "瑞典王国",
        "lower_name": "the kingdom of sweden"
    },
    {
        "id": "204",
        "continent_id": "3",
        "code": "SWZ",
        "name": "Swaziland",
        "full_name": "The Kingdom of Swaziland",
        "cname": "斯威士兰",
        "full_cname": "斯威士兰王国",
        "lower_name": "the kingdom of swaziland"
    },
    {
        "id": "205",
        "continent_id": "3",
        "code": "SYC",
        "name": "Seychelles",
        "full_name": "the Republic of Seychelles",
        "cname": "塞舌尔",
        "full_cname": "塞舌尔共和国",
        "lower_name": "the republic of seychelles"
    },
    {
        "id": "206",
        "continent_id": "1",
        "code": "SYR",
        "name": "Syrian",
        "full_name": "The Syrian Arab Republic",
        "cname": "叙利亚",
        "full_cname": "阿拉伯叙利亚共和国",
        "lower_name": "the syrian arab republic"
    },
    {
        "id": "208",
        "continent_id": "",
        "code": "TCA",
        "name": "",
        "full_name": "",
        "cname": "特克斯和凯克特斯群岛",
        "full_cname": "特克斯和凯克特斯群岛",
        "lower_name": ""
    },
    {
        "id": "209",
        "continent_id": "3",
        "code": "TCD",
        "name": "Chad",
        "full_name": "The Republic of Chad",
        "cname": "乍得",
        "full_cname": "乍得共和国",
        "lower_name": "the republic of chad"
    },
    {
        "id": "210",
        "continent_id": "3",
        "code": "TGO",
        "name": "Togo",
        "full_name": "The Republic of Togo",
        "cname": "多哥",
        "full_cname": "多哥共和国",
        "lower_name": "the republic of togo"
    },
    {
        "id": "211",
        "continent_id": "1",
        "code": "THA",
        "name": "Thailand",
        "full_name": "Kingdom of Thailand",
        "cname": "泰国",
        "full_cname": "泰王国",
        "lower_name": "kingdom of thailand"
    },
    {
        "id": "212",
        "continent_id": "1",
        "code": "TJK",
        "name": "Tajikistan",
        "full_name": "The Republic of Tajikistan",
        "cname": "塔吉克斯坦",
        "full_cname": "塔吉克斯坦共和国",
        "lower_name": "the republic of tajikistan"
    },
    {
        "id": "213",
        "continent_id": "",
        "code": "TKL",
        "name": "",
        "full_name": "",
        "cname": "托克劳",
        "full_cname": "托克劳",
        "lower_name": ""
    },
    {
        "id": "214",
        "continent_id": "1",
        "code": "TKM",
        "name": "Turkmenistan",
        "full_name": "Turkmenistan",
        "cname": "土库曼斯坦",
        "full_cname": "土库曼斯坦",
        "lower_name": "turkmenistan"
    },
    {
        "id": "215",
        "continent_id": "1",
        "code": "TLS",
        "name": "East Timor",
        "full_name": "Democratic Republic of East Timor",
        "cname": "东帝汶",
        "full_cname": "东帝汶民主共和国",
        "lower_name": "democratic republic of east timor"
    },
    {
        "id": "216",
        "continent_id": "4",
        "code": "TON",
        "name": "Tonga",
        "full_name": "The Kingdom of Tonga",
        "cname": "汤加",
        "full_cname": "汤加王国",
        "lower_name": "the kingdom of tonga"
    },
    {
        "id": "217",
        "continent_id": "7",
        "code": "TTO",
        "name": "Trinidad and Tobago",
        "full_name": "Republic of Trinidad and Tobago",
        "cname": "特立尼达和多巴哥",
        "full_cname": "特立尼达和多巴哥共和国",
        "lower_name": "republic of trinidad and tobago"
    },
    {
        "id": "218",
        "continent_id": "3",
        "code": "TUN",
        "name": "Tunisia",
        "full_name": "The Republic of Tunisia",
        "cname": "突尼斯",
        "full_cname": "突尼斯共和国",
        "lower_name": "the republic of tunisia"
    },
    {
        "id": "219",
        "continent_id": "1",
        "code": "TUR",
        "name": "Turkey",
        "full_name": "The Republic of Turkey",
        "cname": "土耳其",
        "full_cname": "土耳其共和国",
        "lower_name": "the republic of turkey"
    },
    {
        "id": "220",
        "continent_id": "4",
        "code": "TUV",
        "name": "Tuvalu",
        "full_name": "Tuvalu",
        "cname": "图瓦卢",
        "full_cname": "图瓦卢",
        "lower_name": "tuvalu"
    },
    {
        "id": "221",
        "continent_id": "3",
        "code": "TZA",
        "name": "Tanzania",
        "full_name": "The United Republic of Tanzania",
        "cname": "坦桑尼亚",
        "full_cname": "坦桑尼亚联合共和国",
        "lower_name": "the united republic of tanzania"
    },
    {
        "id": "222",
        "continent_id": "3",
        "code": "UGA",
        "name": "Uganda",
        "full_name": "The Republic of Uganda",
        "cname": "乌干达",
        "full_cname": "乌干达共和国",
        "lower_name": "the republic of uganda"
    },
    {
        "id": "223",
        "continent_id": "2",
        "code": "UKR",
        "name": "Ukraine",
        "full_name": "Ukraine",
        "cname": "乌克兰",
        "full_cname": "乌克兰",
        "lower_name": "ukraine"
    },
    {
        "id": "224",
        "continent_id": "",
        "code": "UMI",
        "name": "",
        "full_name": "",
        "cname": "美属外岛",
        "full_cname": "美属外岛",
        "lower_name": ""
    },
    {
        "id": "225",
        "continent_id": "7",
        "code": "URY",
        "name": "Uruguay",
        "full_name": "The Oriental Republic of Uruguay",
        "cname": "乌拉圭",
        "full_cname": "乌拉圭东岸共和国",
        "lower_name": "the oriental republic of uruguay"
    },
    {
        "id": "226",
        "continent_id": "6",
        "code": "USA",
        "name": "United States",
        "full_name": "The United States of America",
        "cname": "美国",
        "full_cname": "美利坚合众国",
        "lower_name": "the united states of america"
    },
    {
        "id": "227",
        "continent_id": "1",
        "code": "UZB",
        "name": "Uzbekstan",
        "full_name": "The Republic of Uzbekistan",
        "cname": "乌兹别克斯坦",
        "full_cname": "乌兹别克斯坦共和国",
        "lower_name": "the republic of uzbekistan"
    },
    {
        "id": "228",
        "continent_id": "2",
        "code": "VAT",
        "name": "Vatican City State",
        "full_name": "Vatican City State",
        "cname": "梵蒂冈城国",
        "full_cname": "梵蒂冈城国",
        "lower_name": "vatican city state"
    },
    {
        "id": "229",
        "continent_id": "6",
        "code": "VCT",
        "name": "Saint Vincent and the Grenadines",
        "full_name": "Saint Vincent and the Grenadines",
        "cname": "圣文森特和格纳丁斯",
        "full_cname": "圣文森特和格林纳丁斯",
        "lower_name": "saint vincent and the grenadines"
    },
    {
        "id": "230",
        "continent_id": "7",
        "code": "VEN",
        "name": "Venezuela",
        "full_name": "Bolivarian Republic of Venezuela",
        "cname": "委内瑞拉",
        "full_cname": "委内瑞拉玻利瓦尔共和国",
        "lower_name": "bolivarian republic of venezuela"
    },
    {
        "id": "231",
        "continent_id": "",
        "code": "VGB",
        "name": "",
        "full_name": "",
        "cname": "维尔京群岛，英属",
        "full_cname": "维尔京群岛，英属",
        "lower_name": ""
    },
    {
        "id": "232",
        "continent_id": "",
        "code": "VIR",
        "name": "",
        "full_name": "",
        "cname": "维尔京群岛，美属",
        "full_cname": "维尔京群岛，美属",
        "lower_name": ""
    },
    {
        "id": "233",
        "continent_id": "1",
        "code": "VNM",
        "name": "Vietnam",
        "full_name": "Socialist Republic of Vietnam",
        "cname": "越南",
        "full_cname": "越南社会主义共和国",
        "lower_name": "socialist republic of vietnam"
    },
    {
        "id": "234",
        "continent_id": "4",
        "code": "VUT",
        "name": "Vanuatu",
        "full_name": "Republic of Vanuatu",
        "cname": "瓦努阿图",
        "full_cname": "瓦努阿图共和国",
        "lower_name": "republic of vanuatu"
    },
    {
        "id": "235",
        "continent_id": "",
        "code": "WLF",
        "name": "",
        "full_name": "",
        "cname": "瓦利斯和福图纳",
        "full_cname": "瓦利斯和福图纳",
        "lower_name": ""
    },
    {
        "id": "236",
        "continent_id": "4",
        "code": "WSM",
        "name": "Samoa",
        "full_name": "The Independent State of Samoa",
        "cname": "萨摩亚",
        "full_cname": "萨摩亚独立国",
        "lower_name": "the independent state of samoa"
    },
    {
        "id": "237",
        "continent_id": "1",
        "code": "YEM",
        "name": "Yemen",
        "full_name": "The Republic of Yemen",
        "cname": "也门",
        "full_cname": "也门共和国",
        "lower_name": "the republic of yemen"
    },
    {
        "id": "238",
        "continent_id": "3",
        "code": "ZAF",
        "name": "South Africa",
        "full_name": "The Republic of South Africa",
        "cname": "南非",
        "full_cname": "南非共和国",
        "lower_name": "the republic of south africa"
    },
    {
        "id": "239",
        "continent_id": "3",
        "code": "ZMB",
        "name": "Zambia",
        "full_name": "The Republic of Zambia",
        "cname": "赞比亚",
        "full_cname": "赞比亚共和国",
        "lower_name": "the republic of zambia"
    },
    {
        "id": "240",
        "continent_id": "3",
        "code": "ZWE",
        "name": "Zimbabwe",
        "full_name": "the Republic of Zimbabwe",
        "cname": "津巴布韦",
        "full_cname": "津巴布韦共和国",
        "lower_name": "the republic of zimbabwe"
    }
]
country_with_id.map( e => {
    country_detail.forEach(i=>{
        if(e.code == i.isoAlpha3) {
            e['country_code'] = i.countrycode
        }
    })
    return e
})
import axios from 'axios';
import REGION from '../src/assets/ext/region-code.json';
function Region() {
	function init() {
	     console.log ('ajax')
	     return new Promise(resolve => {
	     })
    }
    function site(num) {
	    let list = REGION;
        if ( num === 'zh') {
	        // await axios
	        // .get('/ext/region-code.json')
	        // .then(res => {
		    //     console.log('load region', res.data.zh);
		    //     list = res.data.zh
	        // })
            list = REGION.zh
	        // console.log ('list',list)
	        list.map(province => {
		        province.children.map(city => delete city.children)
	        })
        } else if( num === 'en' ){
	        // list = init().en;

            list = REGION.en
	        list.map(province => {
		        province.children.map(city => delete city.children)
	        })
        }
	    return list;

    }

    return {
        init: init,
        province: province,
        site: site
    };
}
const abandon = [
    {
        "id": "12",
        "continent_id": "",
        "code": "ASC",
        "name": "",
        "full_name": "",
        "cname": "阿森松岛",
        "full_cname": "阿森松岛",
        "lower_name": ""
    },
    {
        "id": "8",
        "continent_id": "7",
        "code": "ANT",
        "name": "Netherlands Antilles",
        "full_name": "Netherlands Antilles",
        "cname": "荷属安地列斯群岛",
        "full_cname": "荷属安地列斯群岛",
        "lower_name": "netherlands antilles"
    },
    {
        "id": "186",
        "continent_id": "",
        "code": "SCG",
        "name": "",
        "full_name": "",
        "cname": "塞尔维亚,黑山",
        "full_cname": "塞尔维亚,黑山",
        "lower_name": ""
    },
    {
        "id": "207",
        "continent_id": "",
        "code": "TAA",
        "name": "",
        "full_name": "",
        "cname": "特里斯坦达昆哈",
        "full_cname": "特里斯坦达昆哈",
        "lower_name": ""
    }
]
const province = [
        "北京市",
        "天津市",
        "河北省",
        "山西省",
        "内蒙古自治区",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "上海市",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "广西壮族自治区",
        "海南省",
        "重庆市",
        "四川省",
        "贵州省",
        "云南省",
        "西藏自治区",
        "陕西省",
        "甘肃省",
        "青海省",
        "宁夏回族自治区",
        "新疆维吾尔自治区",
        "台湾省",
        "香港特别行政区",
        "澳门特别行政区"]
export default new Region();
